const dictionaryData = [
  {
    latin: '-ne',
    info: '',
    definitions: ['*vraagwoord (niet vertalen)*'],
    chapter: '22',
    searchForm: '-ne',
  },
  {
    latin: '-que',
    info: '',
    definitions: ['en'],
    chapter: '19',
    searchForm: '-que',
  },
  {
    latin: 'a',
    info: '+ abl',
    definitions: ['vanaf', 'door'],
    chapter: '10',
    searchForm: 'a',
  },
  {
    latin: 'ab',
    info: '+ abl',
    definitions: ['vanaf', 'door'],
    chapter: '10',
    searchForm: 'ab',
  },
  {
    latin: 'abesse',
    info: '',
    definitions: ['afwezig zijn'],
    chapter: '5',
    searchForm: 'abesse',
  },
  {
    latin: 'abii',
    info: '',
    definitions: ['*pf van* abire'],
    chapter: '29',
    searchForm: 'abii',
  },
  {
    latin: 'abire',
    info: '',
    definitions: ['weggaan'],
    chapter: '29',
    searchForm: 'abire',
  },
  {
    latin: 'abiturus',
    info: '',
    definitions: ['*pfa van* abire'],
    chapter: '32',
    searchForm: 'abiturus',
  },
  {
    latin: 'ablatus',
    info: '',
    definitions: ['*ppp van* auferre'],
    chapter: '55',
    searchForm: 'ablatus',
  },
  {
    latin: 'abstuli',
    info: '',
    definitions: ['*pf van* auferre'],
    chapter: '55',
    searchForm: 'abstuli',
  },
  {
    latin: 'ac',
    info: '',
    definitions: ['en'],
    chapter: '54',
    searchForm: 'ac',
  },
  {
    latin: 'accedere',
    info: '',
    definitions: ['gaan naar', 'naderen'],
    chapter: '2',
    searchForm: 'accedere',
  },
  {
    latin: 'accendere',
    info: '',
    definitions: ['aansteken, ontsteken'],
    chapter: '17',
    searchForm: 'accendere',
  },
  {
    latin: 'accendi',
    info: '',
    definitions: ['*pf van* accendere'],
    chapter: '17',
    searchForm: 'accendi',
  },
  {
    latin: 'accensus',
    info: '',
    definitions: ['*ppp van* accendere'],
    chapter: '34',
    searchForm: 'accensus',
  },
  {
    latin: 'accepi',
    info: '',
    definitions: ['*pf van* accipere'],
    chapter: '30, 47',
    searchForm: 'accepi',
  },
  {
    latin: 'acceptus',
    info: '',
    definitions: ['*ppp van* accipere'],
    chapter: '30, 47',
    searchForm: 'acceptus',
  },
  {
    latin: 'accessi',
    info: '',
    definitions: ['*pf van* accedere'],
    chapter: '16, 32',
    searchForm: 'accessi',
  },
  {
    latin: 'accessus',
    info: '',
    definitions: ['*ppp van* accedere'],
    chapter: '32',
    searchForm: 'accessus',
  },
  {
    latin: 'accidere',
    info: '',
    definitions: ['gebeuren'],
    chapter: '25',
    searchForm: 'accidere',
  },
  {
    latin: 'accidi',
    info: '',
    definitions: ['*pf van* accidere'],
    chapter: '27',
    searchForm: 'accidi',
  },
  {
    latin: 'accipere, accipio',
    info: '',
    definitions: ['ontvangen, aannemen'],
    chapter: '30',
    searchForm: 'accipere, accipio',
  },
  {
    latin: 'acer, acris, acre',
    info: '',
    definitions: ['scherp, fel'],
    chapter: '17',
    searchForm: 'acer, acris, acre',
  },
  {
    latin: 'acies',
    info: '5',
    definitions: ['slaglinie'],
    chapter: '36',
    searchForm: 'acies',
  },
  {
    latin: 'actus',
    info: '',
    definitions: ['*ppp van* agere'],
    chapter: '39',
    searchForm: 'actus',
  },
  {
    latin: 'ad',
    info: '+ acc',
    definitions: ['naar, tot', 'bij'],
    chapter: '1',
    searchForm: 'ad',
  },
  {
    latin: 'addere',
    info: '',
    definitions: ['toevoegen'],
    chapter: '5',
    searchForm: 'addere',
  },
  {
    latin: 'addidi',
    info: '',
    definitions: ['*pf van* addere'],
    chapter: '25',
    searchForm: 'addidi',
  },
  {
    latin: 'adducere',
    info: '',
    definitions: ['brengen (naar)'],
    chapter: '54',
    searchForm: 'adducere',
  },
  {
    latin: 'adeo',
    info: '',
    definitions: ['zo(zeer)'],
    chapter: '44',
    searchForm: 'adeo',
  },
  {
    latin: 'adesse',
    info: '(+ dat)',
    definitions: ['aanwezig zijn (bij)'],
    chapter: '16',
    searchForm: 'adesse',
  },
  {
    latin: 'adfui',
    info: '',
    definitions: ['*pf van* adesse'],
    chapter: '47',
    searchForm: 'adfui',
  },
  {
    latin: 'adfuturus',
    info: '',
    definitions: ['*pfa van* adesse'],
    chapter: '47',
    searchForm: 'adfuturus',
  },
  {
    latin: 'adhibēre',
    info: '',
    definitions: ['toepassen, gebruiken'],
    chapter: '52',
    searchForm: 'adhibere',
  },
  {
    latin: 'adhuc',
    info: '',
    definitions: ['nog, tot nu toe'],
    chapter: '11',
    searchForm: 'adhuc',
  },
  {
    latin: 'adii',
    info: '',
    definitions: ['*pf van* adire'],
    chapter: '40',
    searchForm: 'adii',
  },
  {
    latin: 'adipisci',
    info: '',
    definitions: ['verkrijgen'],
    chapter: '54',
    searchForm: 'adipisci',
  },
  {
    latin: 'adire (ad)',
    info: '+ acc',
    definitions: ['gaan naar'],
    chapter: '40',
    searchForm: 'adire (ad)',
  },
  {
    latin: 'aditurus',
    info: '',
    definitions: ['*pfa van* adire'],
    chapter: '40',
    searchForm: 'aditurus',
  },
  {
    latin: 'adulescens, -entes',
    info: 'm',
    definitions: ['jongeman, jongen'],
    chapter: '45',
    searchForm: 'adulescens, -entes',
  },
  {
    latin: 'adventus',
    info: '4',
    definitions: ['aankomst'],
    chapter: '37',
    searchForm: 'adventus',
  },
  {
    latin: 'aedificare',
    info: '',
    definitions: ['bouwen'],
    chapter: '3',
    searchForm: 'aedificare',
  },
  {
    latin: 'aedificium',
    info: '',
    definitions: ['gebouw'],
    chapter: '13',
    searchForm: 'aedificium',
  },
  {
    latin: 'aeger, -gra, -grum',
    info: '',
    definitions: ['ziek'],
    chapter: '43',
    searchForm: 'aeger, -gra, -grum',
  },
  {
    latin: 'aestus',
    info: '4',
    definitions: ['hitte', 'branding'],
    chapter: '53',
    searchForm: 'aestus',
  },
  {
    latin: 'aetas, aetates',
    info: 'v',
    definitions: ['leeftijd'],
    chapter: '33',
    searchForm: 'aetas, aetates',
  },
  {
    latin: 'affeci',
    info: '',
    definitions: ['*pf van* afficere'],
    chapter: '33',
    searchForm: 'affeci',
  },
  {
    latin: 'affectus',
    info: '',
    definitions: ['*ppp van* afficere'],
    chapter: '33',
    searchForm: 'affectus',
  },
  {
    latin: 'afferre',
    info: '',
    definitions: ['(mee)brengen'],
    chapter: '32',
    searchForm: 'afferre',
  },
  {
    latin: 'afficere, afficio',
    info: '',
    definitions: ['treffen, vervullen'],
    chapter: '33',
    searchForm: 'afficere, afficio',
  },
  {
    latin: 'ager *mv* agri',
    info: '',
    definitions: ['akker'],
    chapter: '20',
    searchForm: 'ager *mv* agri',
  },
  {
    latin: 'agere',
    info: '',
    definitions: ['leiden, voeren', 'doen'],
    chapter: '18',
    searchForm: 'agere',
  },
  {
    latin: 'aggredi, aggredior',
    info: '',
    definitions: ['aanvallen', 'beginnen (aan)'],
    chapter: '51',
    searchForm: 'aggredi, aggredior',
  },
  {
    latin: 'aggressus sum',
    info: '',
    definitions: ['*pf van* aggredi'],
    chapter: '51',
    searchForm: 'aggressus sum',
  },
  {
    latin: 'agmen, agmina',
    info: '',
    definitions: ['rij, stoet'],
    chapter: '10',
    searchForm: 'agmen, agmina',
  },
  {
    latin: 'alere',
    info: '',
    definitions: ['voeden'],
    chapter: '45',
    searchForm: 'alere',
  },
  {
    latin: 'alienus, -a, -um',
    info: '',
    definitions: ['vreemd, van een ander'],
    chapter: '54',
    searchForm: 'alienus, -a, -um',
  },
  {
    latin: 'alii … alii',
    info: 'mv',
    definitions: ['sommige(n) … andere(n)'],
    chapter: '51',
    searchForm: 'alii … alii',
  },
  {
    latin: 'aliqui, aliqua, aliquod',
    info: '',
    definitions: [
      '**ev** een (zekere), een of andere',
      '**mv** sommige, enige',
    ],
    chapter: '46',
    searchForm: 'aliqui, aliqua, aliquod',
  },
  {
    latin: 'aliquid',
    info: '',
    definitions: ['iets'],
    chapter: '45',
    searchForm: 'aliquid',
  },
  {
    latin: 'aliquis',
    info: '',
    definitions: ['iemand'],
    chapter: '45',
    searchForm: 'aliquis',
  },
  {
    latin: 'alius … alius',
    info: '',
    definitions: ['de een … de ander'],
    chapter: '25',
    searchForm: 'alius … alius',
  },
  {
    latin: 'alius, alia, aliud',
    info: '',
    definitions: ['ander'],
    chapter: '18',
    searchForm: 'alius, alia, aliud',
  },
  {
    latin: 'allatus',
    info: '',
    definitions: ['*ppp van* afferre'],
    chapter: '32',
    searchForm: 'allatus',
  },
  {
    latin: 'altus, -a, -um',
    info: '',
    definitions: ['hoog', 'diep'],
    chapter: '19',
    searchForm: 'altus, -a, -um',
  },
  {
    latin: 'amare',
    info: '',
    definitions: ['houden van, liefhebben'],
    chapter: '6',
    searchForm: 'amare',
  },
  {
    latin: 'amica',
    info: '',
    definitions: ['vriendin'],
    chapter: '1',
    searchForm: 'amica',
  },
  {
    latin: 'amicus',
    info: '',
    definitions: ['vriend'],
    chapter: '3',
    searchForm: 'amicus',
  },
  {
    latin: 'amisi',
    info: '',
    definitions: ['*pf van* amittere'],
    chapter: '15, 51',
    searchForm: 'amisi',
  },
  {
    latin: 'amissus',
    info: '',
    definitions: ['*ppp van* amittere'],
    chapter: '51',
    searchForm: 'amissus',
  },
  {
    latin: 'amittere',
    info: '',
    definitions: ['verliezen'],
    chapter: '15',
    searchForm: 'amittere',
  },
  {
    latin: 'amor, amores',
    info: 'm',
    definitions: ['liefde'],
    chapter: '15',
    searchForm: 'amor, amores',
  },
  {
    latin: 'amplus, -a, -um',
    info: '',
    definitions: ['ruim, groot', 'belangrijk'],
    chapter: '26',
    searchForm: 'amplus, -a, -um',
  },
  {
    latin: 'an',
    info: 'in vraag',
    definitions: ['of'],
    chapter: '47',
    searchForm: 'an',
  },
  {
    latin: 'animal, animalia',
    info: 'o',
    definitions: ['dier'],
    chapter: '9',
    searchForm: 'animal, animalia',
  },
  {
    latin: 'animus',
    info: '',
    definitions: ['geest, aandacht'],
    chapter: '29',
    searchForm: 'animus',
  },
  {
    latin: 'annus',
    info: '',
    definitions: ['jaar'],
    chapter: '5',
    searchForm: 'annus',
  },
  {
    latin: 'ante',
    info: '+ acc',
    definitions: ['voor'],
    chapter: '8, 41',
    searchForm: 'ante',
  },
  {
    latin: 'ante',
    info: 'bijw',
    definitions: ['eerder'],
    chapter: '41',
    searchForm: 'ante',
  },
  {
    latin: 'antea',
    info: '',
    definitions: ['eerder'],
    chapter: '11',
    searchForm: 'antea',
  },
  {
    latin: 'anxius, -a, -um',
    info: '',
    definitions: ['angstig, bezorgd'],
    chapter: '27',
    searchForm: 'anxius, -a, -um',
  },
  {
    latin: 'aperire',
    info: '',
    definitions: ['openen'],
    chapter: '30',
    searchForm: 'aperire',
  },
  {
    latin: 'apparēre',
    info: '',
    definitions: ['verschijnen', 'duidelijk zijn'],
    chapter: '17, 47',
    searchForm: 'apparere',
  },
  {
    latin: 'appropinquare',
    info: '+ dat',
    definitions: ['naderen'],
    chapter: '11',
    searchForm: 'appropinquare',
  },
  {
    latin: 'apud',
    info: '+ acc',
    definitions: ['bij'],
    chapter: '13',
    searchForm: 'apud',
  },
  {
    latin: 'aqua',
    info: '',
    definitions: ['water'],
    chapter: '1',
    searchForm: 'aqua',
  },
  {
    latin: 'ara',
    info: '',
    definitions: ['altaar'],
    chapter: '29',
    searchForm: 'ara',
  },
  {
    latin: 'arbor, arbores',
    info: '',
    definitions: ['boom'],
    chapter: '1',
    searchForm: 'arbor, arbores',
  },
  {
    latin: 'arcessere',
    info: '',
    definitions: ['laten komen'],
    chapter: '22',
    searchForm: 'arcessere',
  },
  {
    latin: 'arcessitus',
    info: '',
    definitions: ['*ppp van* arcessere'],
    chapter: '43',
    searchForm: 'arcessitus',
  },
  {
    latin: 'arcessivi',
    info: '',
    definitions: ['*pf van* arcessere'],
    chapter: '22, 43',
    searchForm: 'arcessivi',
  },
  {
    latin: 'ardēre',
    info: '',
    definitions: ['branden'],
    chapter: '5',
    searchForm: 'ardere',
  },
  {
    latin: 'arma',
    info: 'mv',
    definitions: ['wapens'],
    chapter: '4',
    searchForm: 'arma',
  },
  {
    latin: 'ars, artes',
    info: 'v',
    definitions: ['vaardigheid, kunst'],
    chapter: '29',
    searchForm: 'ars, artes',
  },
  {
    latin: 'arx, arces',
    info: 'v',
    definitions: ['burcht'],
    chapter: '4',
    searchForm: 'arx, arces',
  },
  {
    latin: 'ascendere',
    info: '',
    definitions: ['bestijgen, klimmen (op)'],
    chapter: '32',
    searchForm: 'ascendere',
  },
  {
    latin: 'ascendi',
    info: '',
    definitions: ['*pf van* ascendere'],
    chapter: '32',
    searchForm: 'ascendi',
  },
  {
    latin: 'ascensus',
    info: '',
    definitions: ['*ppp van* ascendere'],
    chapter: '32',
    searchForm: 'ascensus',
  },
  {
    latin: 'aspexi',
    info: '',
    definitions: ['*pf van* aspicere'],
    chapter: '23',
    searchForm: 'aspexi',
  },
  {
    latin: 'aspicere, aspicio',
    info: '',
    definitions: ['bekijken, aankijken'],
    chapter: '23',
    searchForm: 'aspicere, aspicio',
  },
  {
    latin: 'at',
    info: '',
    definitions: ['maar'],
    chapter: '22',
    searchForm: 'at',
  },
  {
    latin: 'atque',
    info: '',
    definitions: ['en'],
    chapter: '32',
    searchForm: 'atque',
  },
  {
    latin: 'attuli',
    info: '',
    definitions: ['*pf van* afferre'],
    chapter: '32',
    searchForm: 'attuli',
  },
  {
    latin: 'audacia',
    info: '',
    definitions: ['(over)moed'],
    chapter: '43',
    searchForm: 'audacia',
  },
  {
    latin: 'audax, audac-',
    info: '',
    definitions: ['moedig, roekeloos'],
    chapter: '19',
    searchForm: 'audax, audac-',
  },
  {
    latin: 'audēre',
    info: '',
    definitions: ['durven'],
    chapter: '20',
    searchForm: 'audere',
  },
  {
    latin: 'audire',
    info: '',
    definitions: ['horen'],
    chapter: '1',
    searchForm: 'audire',
  },
  {
    latin: 'auferre',
    info: '',
    definitions: ['wegnemen', '**se** zich verwijderen'],
    chapter: '55',
    searchForm: 'auferre',
  },
  {
    latin: 'augēre',
    info: '',
    definitions: ['vergroten, vermeerderen'],
    chapter: '47',
    searchForm: 'augere',
  },
  {
    latin: 'aureus, -a, -um',
    info: '',
    definitions: ['gouden, van goud'],
    chapter: '48',
    searchForm: 'aureus, -a, -um',
  },
  {
    latin: 'ausus sum',
    info: '',
    definitions: ['*pf van* audēre'],
    chapter: '50',
    searchForm: 'ausus sum',
  },
  {
    latin: 'aut',
    info: '',
    definitions: ['of'],
    chapter: '8',
    searchForm: 'aut',
  },
  {
    latin: 'autem',
    info: '',
    definitions: ['echter'],
    chapter: '5',
    searchForm: 'autem',
  },
  {
    latin: 'auxilium',
    info: '',
    definitions: ['hulp', '**mv** hulptroepen'],
    chapter: '4, 37',
    searchForm: 'auxilium',
  },
  {
    latin: 'avus',
    info: '',
    definitions: ['grootvader'],
    chapter: '52',
    searchForm: 'avus',
  },
  {
    latin: 'barbarus',
    info: '',
    definitions: ['barbaar'],
    chapter: '37',
    searchForm: 'barbarus',
  },
  {
    latin: 'barbarus, -a, -um',
    info: '',
    definitions: ['barbaars'],
    chapter: '37',
    searchForm: 'barbarus, -a, -um',
  },
  {
    latin: 'bellum',
    info: '',
    definitions: ['oorlog'],
    chapter: '6',
    searchForm: 'bellum',
  },
  {
    latin: 'bene',
    info: 'bijw',
    definitions: ['goed'],
    chapter: '17',
    searchForm: 'bene',
  },
  {
    latin: 'bibere',
    info: '',
    definitions: ['drinken'],
    chapter: '2',
    searchForm: 'bibere',
  },
  {
    latin: 'bibi',
    info: '',
    definitions: ['*pf van* bibere'],
    chapter: '34',
    searchForm: 'bibi',
  },
  {
    latin: 'bis',
    info: '',
    definitions: ['tweemaal'],
    chapter: '37',
    searchForm: 'bis',
  },
  {
    latin: 'bona',
    info: 'mv',
    definitions: ['goederen'],
    chapter: '45',
    searchForm: 'bona',
  },
  {
    latin: 'bonus, -a, -um',
    info: '',
    definitions: ['goed'],
    chapter: '15',
    searchForm: 'bonus, -a, -um',
  },
  {
    latin: 'brevis, -e',
    info: '',
    definitions: ['kort'],
    chapter: '16',
    searchForm: 'brevis, -e',
  },
  {
    latin: 'cadere',
    info: '',
    definitions: ['vallen'],
    chapter: '4',
    searchForm: 'cadere',
  },
  {
    latin: 'campus',
    info: '',
    definitions: ['veld'],
    chapter: '31',
    searchForm: 'campus',
  },
  {
    latin: 'canere',
    info: '',
    definitions: ['zingen'],
    chapter: '25',
    searchForm: 'canere',
  },
  {
    latin: 'canis, canes',
    info: 'm',
    definitions: ['hond'],
    chapter: '34',
    searchForm: 'canis, canes',
  },
  {
    latin: 'capere, capio',
    info: '',
    definitions: ['pakken, nemen'],
    chapter: '13',
    searchForm: 'capere, capio',
  },
  {
    latin: 'captivus',
    info: '',
    definitions: ['krijgsgevangene'],
    chapter: '46',
    searchForm: 'captivus',
  },
  {
    latin: 'captivus, -a, -um',
    info: '',
    definitions: ['krijgsgevangen'],
    chapter: '46',
    searchForm: 'captivus, -a, -um',
  },
  {
    latin: 'captus',
    info: '',
    definitions: ['*ppp van* capere'],
    chapter: '37',
    searchForm: 'captus',
  },
  {
    latin: 'caput, capita',
    info: '',
    definitions: ['hoofd'],
    chapter: '10',
    searchForm: 'caput, capita',
  },
  {
    latin: 'carēre',
    info: '+ abl',
    definitions: ['missen'],
    chapter: '17',
    searchForm: 'carere',
  },
  {
    latin: 'carmen, carmina',
    info: '',
    definitions: ['lied, gedicht'],
    chapter: '25',
    searchForm: 'carmen, carmina',
  },
  {
    latin: 'carus, -a, -um',
    info: '',
    definitions: ['geliefd'],
    chapter: '15',
    searchForm: 'carus, -a, -um',
  },
  {
    latin: 'castra',
    info: 'mv',
    definitions: ['legerkamp'],
    chapter: '30',
    searchForm: 'castra',
  },
  {
    latin: 'causa',
    info: 'gen +',
    definitions: ['wegens'],
    chapter: '54',
    searchForm: 'causa',
  },
  {
    latin: 'causa',
    info: '',
    definitions: ['reden'],
    chapter: '11',
    searchForm: 'causa',
  },
  {
    latin: 'cavēre',
    info: '(+ acc)',
    definitions: ['oppassen (voor)'],
    chapter: '41',
    searchForm: 'cavere',
  },
  {
    latin: 'cecidi',
    info: '',
    definitions: ['*pf van* cadere'],
    chapter: '12',
    searchForm: 'cecidi',
  },
  {
    latin: 'cedere',
    info: '',
    definitions: ['(aan de kant) gaan', 'toegeven'],
    chapter: '12',
    searchForm: 'cedere',
  },
  {
    latin: 'celebrare',
    info: '',
    definitions: ['(feest)vieren'],
    chapter: '6',
    searchForm: 'celebrare',
  },
  {
    latin: 'celer, celeris, celere',
    info: '',
    definitions: ['snel'],
    chapter: '17',
    searchForm: 'celer, celeris, celere',
  },
  {
    latin: 'cena',
    info: '',
    definitions: ['maaltijd'],
    chapter: '16',
    searchForm: 'cena',
  },
  {
    latin: 'censēre',
    info: '',
    definitions: ['van mening zijn'],
    chapter: '26',
    searchForm: 'censere',
  },
  {
    latin: 'centum',
    info: '',
    definitions: ['honderd'],
    chapter: '11',
    searchForm: 'centum',
  },
  {
    latin: 'centurio, -ones',
    info: 'm',
    definitions: ['centurio, officier'],
    chapter: '37',
    searchForm: 'centurio, -ones',
  },
  {
    latin: 'cepi',
    info: '',
    definitions: ['*pf van* capere'],
    chapter: '19',
    searchForm: 'cepi',
  },
  {
    latin: 'cernere',
    info: '',
    definitions: ['onderscheiden, zien'],
    chapter: '44',
    searchForm: 'cernere',
  },
  {
    latin: 'certamen, certamina',
    info: '',
    definitions: ['wedstrijd'],
    chapter: '12',
    searchForm: 'certamen, certamina',
  },
  {
    latin: 'certare',
    info: '',
    definitions: ['strijden'],
    chapter: '36',
    searchForm: 'certare',
  },
  {
    latin: 'certus, -a, -um',
    info: '',
    definitions: ['zeker, vast'],
    chapter: '25',
    searchForm: 'certus, -a, -um',
  },
  {
    latin: 'ceteri, -ae, -a',
    info: 'mv',
    definitions: ['(de) andere, overige'],
    chapter: '18',
    searchForm: 'ceteri, -ae, -a',
  },
  {
    latin: 'cibus',
    info: '',
    definitions: ['voedsel'],
    chapter: '19',
    searchForm: 'cibus',
  },
  {
    latin: 'cingere',
    info: '',
    definitions: ['omringen'],
    chapter: '53',
    searchForm: 'cingere',
  },
  {
    latin: 'cito',
    info: 'bijw',
    definitions: ['snel'],
    chapter: '9',
    searchForm: 'cito',
  },
  {
    latin: 'civilis, -e',
    info: '',
    definitions: ['burger-', 'openbaar'],
    chapter: '39',
    searchForm: 'civilis, -e',
  },
  {
    latin: 'civis, cives',
    info: 'm',
    definitions: ['burger'],
    chapter: '3',
    searchForm: 'civis, cives',
  },
  {
    latin: 'civitas, civitates',
    info: 'v',
    definitions: ['burgerij', 'stad'],
    chapter: '39',
    searchForm: 'civitas, civitates',
  },
  {
    latin: 'clades, clades',
    info: 'v',
    definitions: ['nederlaag'],
    chapter: '30',
    searchForm: 'clades, clades',
  },
  {
    latin: 'clamare',
    info: '',
    definitions: ['schreeuwen'],
    chapter: '1',
    searchForm: 'clamare',
  },
  {
    latin: 'clamor, clamores',
    info: 'm',
    definitions: ['geschreeuw'],
    chapter: '19',
    searchForm: 'clamor, clamores',
  },
  {
    latin: 'clarus, -a, -um',
    info: '',
    definitions: ['helder', 'beroemd'],
    chapter: '22',
    searchForm: 'clarus, -a, -um',
  },
  {
    latin: 'classis, classes',
    info: 'v',
    definitions: ['vloot'],
    chapter: '53',
    searchForm: 'classis, classes',
  },
  {
    latin: 'claudere',
    info: '',
    definitions: ['sluiten'],
    chapter: '9',
    searchForm: 'claudere',
  },
  {
    latin: 'clausi',
    info: '',
    definitions: ['*pf van* claudere'],
    chapter: '38',
    searchForm: 'clausi',
  },
  {
    latin: 'clausus',
    info: '',
    definitions: ['*ppp van* claudere'],
    chapter: '38',
    searchForm: 'clausus',
  },
  {
    latin: 'clementia',
    info: '',
    definitions: ['genade, mildheid'],
    chapter: '39',
    searchForm: 'clementia',
  },
  {
    latin: 'coactus',
    info: '',
    definitions: ['*ppp van* cogere'],
    chapter: '41',
    searchForm: 'coactus',
  },
  {
    latin: 'coegi',
    info: '',
    definitions: ['*pf van* cogere'],
    chapter: '27',
    searchForm: 'coegi',
  },
  {
    latin: 'coepi',
    info: 'pf',
    definitions: ['ik ben begonnen'],
    chapter: '39',
    searchForm: 'coepi',
  },
  {
    latin: 'cogere',
    info: '',
    definitions: ['bijeenbrengen', 'dwingen'],
    chapter: '27',
    searchForm: 'cogere',
  },
  {
    latin: 'cogitare',
    info: '',
    definitions: ['(na)denken'],
    chapter: '2',
    searchForm: 'cogitare',
  },
  {
    latin: 'cognitus',
    info: '',
    definitions: ['*ppp van* cognoscere'],
    chapter: '44',
    searchForm: 'cognitus',
  },
  {
    latin: 'cognoscere',
    info: '',
    definitions: ['te weten komen', 'leren kennen'],
    chapter: '44',
    searchForm: 'cognoscere',
  },
  {
    latin: 'cognovi',
    info: 'pf',
    definitions: ['weten', 'kennen'],
    chapter: '44',
    searchForm: 'cognovi',
  },
  {
    latin: 'cohors, cohortes',
    info: 'v',
    definitions: ['cohort'],
    chapter: '54',
    searchForm: 'cohors, cohortes',
  },
  {
    latin: 'colere',
    info: '',
    definitions: ['verzorgen', 'bebouwen', 'vereren'],
    chapter: '29',
    searchForm: 'colere',
  },
  {
    latin: 'collectus',
    info: '',
    definitions: ['*ppp van* colligere'],
    chapter: '33',
    searchForm: 'collectus',
  },
  {
    latin: 'collegi',
    info: '',
    definitions: ['*pf van* colligere'],
    chapter: '29',
    searchForm: 'collegi',
  },
  {
    latin: 'colligere',
    info: '',
    definitions: ['verzamelen'],
    chapter: '25',
    searchForm: 'colligere',
  },
  {
    latin: 'color, colores',
    info: 'm',
    definitions: ['kleur'],
    chapter: '37',
    searchForm: 'color, colores',
  },
  {
    latin: 'comes, comites',
    info: 'm',
    definitions: ['metgezel'],
    chapter: '44',
    searchForm: 'comes, comites',
  },
  {
    latin: 'commisi',
    info: '',
    definitions: ['*pf van* committere'],
    chapter: '26',
    searchForm: 'commisi',
  },
  {
    latin: 'committere',
    info: '',
    definitions: ['toevertrouwen', '**scelus** begaan', '**proelium** aangaan'],
    chapter: '26, 54',
    searchForm: 'committere',
  },
  {
    latin: 'communis, -e',
    info: '',
    definitions: ['gemeenschappelijk'],
    chapter: '16',
    searchForm: 'communis, -e',
  },
  {
    latin: 'complecti',
    info: '',
    definitions: ['omarmen'],
    chapter: '52',
    searchForm: 'complecti',
  },
  {
    latin: 'complēre',
    info: '',
    definitions: ['vullen'],
    chapter: '8',
    searchForm: 'complere',
  },
  {
    latin: 'complexus sum',
    info: '',
    definitions: ['*pf van* complecti'],
    chapter: '52',
    searchForm: 'complexus sum',
  },
  {
    latin: 'conari',
    info: '',
    definitions: ['proberen'],
    chapter: '50',
    searchForm: 'conari',
  },
  {
    latin: 'condere',
    info: '',
    definitions: ['stichten', 'verbergen'],
    chapter: '24',
    searchForm: 'condere',
  },
  {
    latin: 'condicio, -ones',
    info: 'v',
    definitions: ['voorwaarde', 'toestand'],
    chapter: '54',
    searchForm: 'condicio, -ones',
  },
  {
    latin: 'condidi',
    info: '',
    definitions: ['*pf van* condere'],
    chapter: '24',
    searchForm: 'condidi',
  },
  {
    latin: 'conditus',
    info: '',
    definitions: ['*ppp van* condere'],
    chapter: '40',
    searchForm: 'conditus',
  },
  {
    latin: 'confirmare',
    info: '',
    definitions: ['bevestigen'],
    chapter: '34',
    searchForm: 'confirmare',
  },
  {
    latin: 'coniungere',
    info: '',
    definitions: ['verbinden'],
    chapter: '22',
    searchForm: 'coniungere',
  },
  {
    latin: 'coniunx, coniuges',
    info: '',
    definitions: ['**m** echtgenoot', '**v** echtgenote'],
    chapter: '52',
    searchForm: 'coniunx, coniuges',
  },
  {
    latin: 'consilium',
    info: '',
    definitions: ['plan', 'besluit'],
    chapter: '15',
    searchForm: 'consilium',
  },
  {
    latin: 'consistere',
    info: '',
    definitions: ['blijven staan'],
    chapter: '11',
    searchForm: 'consistere',
  },
  {
    latin: 'conspectus',
    info: '4',
    definitions: ['aanblik'],
    chapter: '48',
    searchForm: 'conspectus',
  },
  {
    latin: 'conspexi',
    info: '',
    definitions: ['*pf van* conspicere'],
    chapter: '23',
    searchForm: 'conspexi',
  },
  {
    latin: 'conspicere, conspicio',
    info: '',
    definitions: ['zien'],
    chapter: '23',
    searchForm: 'conspicere, conspicio',
  },
  {
    latin: 'constat',
    info: '',
    definitions: ['het staat vast'],
    chapter: '33',
    searchForm: 'constat',
  },
  {
    latin: 'constiti',
    info: '',
    definitions: ['*pf van* consistere'],
    chapter: '12',
    searchForm: 'constiti',
  },
  {
    latin: 'constituere',
    info: '',
    definitions: ['besluiten'],
    chapter: '20',
    searchForm: 'constituere',
  },
  {
    latin: 'constitui',
    info: '',
    definitions: ['*pf van* constituere'],
    chapter: '20',
    searchForm: 'constitui',
  },
  {
    latin: 'consul, consules',
    info: 'm',
    definitions: ['consul'],
    chapter: '20',
    searchForm: 'consul, consules',
  },
  {
    latin: 'consulere',
    info: '',
    definitions: ['beraadslagen', '**+ acc** raadplegen'],
    chapter: '48',
    searchForm: 'consulere',
  },
  {
    latin: 'consultus',
    info: '',
    definitions: ['*ppp van* consulere'],
    chapter: '48',
    searchForm: 'consultus',
  },
  {
    latin: 'consului',
    info: '',
    definitions: ['*pf van* consulere'],
    chapter: '48',
    searchForm: 'consului',
  },
  {
    latin: 'contemnere',
    info: '',
    definitions: ['minachten'],
    chapter: '34',
    searchForm: 'contemnere',
  },
  {
    latin: 'contempsi',
    info: '',
    definitions: ['*pf van* contemnere'],
    chapter: '34',
    searchForm: 'contempsi',
  },
  {
    latin: 'contemptus',
    info: '',
    definitions: ['*ppp van* contemnere'],
    chapter: '34',
    searchForm: 'contemptus',
  },
  {
    latin: 'contentus, -a, -um',
    info: '(+ abl)',
    definitions: ['tevreden (met)'],
    chapter: '15',
    searchForm: 'contentus, -a, -um',
  },
  {
    latin: 'contigi',
    info: '',
    definitions: ['*pf van* contingere'],
    chapter: '41',
    searchForm: 'contigi',
  },
  {
    latin: 'continēre',
    info: '',
    definitions: ['bijeenhouden', 'bevatten'],
    chapter: '47',
    searchForm: 'continere',
  },
  {
    latin: 'contingere',
    info: '',
    definitions: ['**+ acc** aanraken', 'gebeuren'],
    chapter: '41',
    searchForm: 'contingere',
  },
  {
    latin: 'contra',
    info: '+ acc',
    definitions: ['tegen(over)'],
    chapter: '11',
    searchForm: 'contra',
  },
  {
    latin: 'conveni',
    info: '',
    definitions: ['*pf van* convenire'],
    chapter: '30',
    searchForm: 'conveni',
  },
  {
    latin: 'convenire',
    info: '',
    definitions: ['bijeenkomen', '**+ acc** ontmoeten'],
    chapter: '30, 41',
    searchForm: 'convenire',
  },
  {
    latin: 'conventus',
    info: '',
    definitions: ['*ppp van* convenire'],
    chapter: '30',
    searchForm: 'conventus',
  },
  {
    latin: 'conversus',
    info: '',
    definitions: ['*ppp van* convertere'],
    chapter: '48',
    searchForm: 'conversus',
  },
  {
    latin: 'convertere',
    info: '',
    definitions: ['(om)draaien'],
    chapter: '48',
    searchForm: 'convertere',
  },
  {
    latin: 'converti',
    info: '',
    definitions: ['*pf van* convertere'],
    chapter: '48',
    searchForm: 'converti',
  },
  {
    latin: 'convocare',
    info: '',
    definitions: ['bijeenroepen'],
    chapter: '38',
    searchForm: 'convocare',
  },
  {
    latin: 'copiae',
    info: 'mv',
    definitions: ['troepen'],
    chapter: '29',
    searchForm: 'copiae',
  },
  {
    latin: 'cornu',
    info: '4',
    definitions: ['hoorn'],
    chapter: '36',
    searchForm: 'cornu',
  },
  {
    latin: 'corpus, corpora',
    info: '',
    definitions: ['lichaam'],
    chapter: '10',
    searchForm: 'corpus, corpora',
  },
  {
    latin: 'corrumpere',
    info: '',
    definitions: ['bederven', 'omkopen'],
    chapter: '37',
    searchForm: 'corrumpere',
  },
  {
    latin: 'cotidie',
    info: '',
    definitions: ['dagelijks'],
    chapter: '20',
    searchForm: 'cotidie',
  },
  {
    latin: 'cras',
    info: '',
    definitions: ['morgen'],
    chapter: '30',
    searchForm: 'cras',
  },
  {
    latin: 'credere',
    info: '+ dat',
    definitions: ['geloven'],
    chapter: '13',
    searchForm: 'credere',
  },
  {
    latin: 'credidi',
    info: '',
    definitions: ['*pf van* credere'],
    chapter: '18',
    searchForm: 'credidi',
  },
  {
    latin: 'crescere',
    info: '',
    definitions: ['groeien'],
    chapter: '20',
    searchForm: 'crescere',
  },
  {
    latin: 'cretus',
    info: '',
    definitions: ['*ppp van* cernere'],
    chapter: '44',
    searchForm: 'cretus',
  },
  {
    latin: 'crevi',
    info: '',
    definitions: ['*pf van* cernere'],
    chapter: '44',
    searchForm: 'crevi',
  },
  {
    latin: 'crudelis, -e',
    info: '',
    definitions: ['wreed'],
    chapter: '19',
    searchForm: 'crudelis, -e',
  },
  {
    latin: 'cucurri',
    info: '',
    definitions: ['*pf van* currere'],
    chapter: '13',
    searchForm: 'cucurri',
  },
  {
    latin: 'culpa',
    info: '',
    definitions: ['schuld'],
    chapter: '5',
    searchForm: 'culpa',
  },
  {
    latin: 'cultus',
    info: '4',
    definitions: ['verzorging, beschaving', 'verering'],
    chapter: '47',
    searchForm: 'cultus',
  },
  {
    latin: 'cum',
    info: '+ abl',
    definitions: ['met'],
    chapter: '3',
    searchForm: 'cum',
  },
  {
    latin: 'cum',
    info: '+ conj',
    definitions: ['toen, nadat', 'omdat', 'hoewel'],
    chapter: '44',
    searchForm: 'cum',
  },
  {
    latin: 'cum',
    info: '+ ind',
    definitions: ['wanneer, toen'],
    chapter: '23',
    searchForm: 'cum',
  },
  {
    latin: 'cuncti, -ae, -a',
    info: 'mv',
    definitions: ['**bnw** alle', '**znw** allen, alles'],
    chapter: '23',
    searchForm: 'cuncti, -ae, -a',
  },
  {
    latin: 'cupere, cupio',
    info: '',
    definitions: ['graag willen, verlangen'],
    chapter: '6',
    searchForm: 'cupere, cupio',
  },
  {
    latin: 'cupivi',
    info: '',
    definitions: ['*pf van* cupere'],
    chapter: '24',
    searchForm: 'cupivi',
  },
  {
    latin: 'cur',
    info: '',
    definitions: ['waarom'],
    chapter: '3',
    searchForm: 'cur',
  },
  {
    latin: 'curare',
    info: '+ acc',
    definitions: ['verzorgen, zorgen voor'],
    chapter: '8',
    searchForm: 'curare',
  },
  {
    latin: 'curia',
    info: '',
    definitions: ['senaatsgebouw'],
    chapter: '30',
    searchForm: 'curia',
  },
  {
    latin: 'currere',
    info: '',
    definitions: ['rennen'],
    chapter: '9',
    searchForm: 'currere',
  },
  {
    latin: 'currus',
    info: '4',
    definitions: ['wagen'],
    chapter: '52',
    searchForm: 'currus',
  },
  {
    latin: 'custodire',
    info: '',
    definitions: ['bewaken'],
    chapter: '2',
    searchForm: 'custodire',
  },
  {
    latin: 'custos, custodes',
    info: 'm',
    definitions: ['bewaker'],
    chapter: '4',
    searchForm: 'custos, custodes',
  },
  {
    latin: 'dare',
    info: '',
    definitions: ['geven'],
    chapter: '2',
    searchForm: 'dare',
  },
  {
    latin: 'datum',
    info: '',
    definitions: ['*ppp van* dare'],
    chapter: '37',
    searchForm: 'datum',
  },
  {
    latin: 'de',
    info: '+ abl',
    definitions: ['van(af)', 'over'],
    chapter: '3',
    searchForm: 'de',
  },
  {
    latin: 'dea',
    info: '',
    definitions: ['godin'],
    chapter: '5',
    searchForm: 'dea',
  },
  {
    latin: 'debēre',
    info: '',
    definitions: ['moeten'],
    chapter: '5',
    searchForm: 'debere',
  },
  {
    latin: 'decernere',
    info: '',
    definitions: ['beslissen'],
    chapter: '36',
    searchForm: 'decernere',
  },
  {
    latin: 'decet',
    info: '+ acc',
    definitions: ['(het) past bij'],
    chapter: '22',
    searchForm: 'decet',
  },
  {
    latin: 'decretus',
    info: '',
    definitions: ['*ppp van* decernere'],
    chapter: '47',
    searchForm: 'decretus',
  },
  {
    latin: 'decrevi',
    info: '',
    definitions: ['*pf van* decernere'],
    chapter: '47',
    searchForm: 'decrevi',
  },
  {
    latin: 'dedere (se)',
    info: '',
    definitions: ['(zich) overgeven'],
    chapter: '38',
    searchForm: 'dedere (se)',
  },
  {
    latin: 'dedi',
    info: '',
    definitions: ['*pf van* dare'],
    chapter: '13',
    searchForm: 'dedi',
  },
  {
    latin: 'dedidi',
    info: '',
    definitions: ['*pf van* dedere (se)'],
    chapter: '46',
    searchForm: 'dedidi',
  },
  {
    latin: 'deditus',
    info: '',
    definitions: ['*ppp van* dedere (se)'],
    chapter: '46',
    searchForm: 'deditus',
  },
  {
    latin: 'defendere',
    info: '',
    definitions: ['verdedigen'],
    chapter: '30',
    searchForm: 'defendere',
  },
  {
    latin: 'deficere, deficio',
    info: '',
    definitions: ['ontbreken'],
    chapter: '23',
    searchForm: 'deficere, deficio',
  },
  {
    latin: 'deicere, deicio',
    info: '',
    definitions: ['neergooien, afwerpen'],
    chapter: '32',
    searchForm: 'deicere, deicio',
  },
  {
    latin: 'deieci',
    info: '',
    definitions: ['*pf van* deicere'],
    chapter: '32',
    searchForm: 'deieci',
  },
  {
    latin: 'deiectus',
    info: '',
    definitions: ['*ppp van* deicere'],
    chapter: '32',
    searchForm: 'deiectus',
  },
  {
    latin: 'deinde',
    info: '',
    definitions: ['daarna'],
    chapter: '9',
    searchForm: 'deinde',
  },
  {
    latin: 'delectare',
    info: '',
    definitions: ['blij maken'],
    chapter: '48',
    searchForm: 'delectare',
  },
  {
    latin: 'delēre',
    info: '',
    definitions: ['vernielen'],
    chapter: '27',
    searchForm: 'delere',
  },
  {
    latin: 'demisi',
    info: '',
    definitions: ['*pf van* demittere'],
    chapter: '44',
    searchForm: 'demisi',
  },
  {
    latin: 'demissus',
    info: '',
    definitions: ['*ppp van* demittere'],
    chapter: '44',
    searchForm: 'demissus',
  },
  {
    latin: 'demittere',
    info: '',
    definitions: ['laten zakken, neerlaten'],
    chapter: '44',
    searchForm: 'demittere',
  },
  {
    latin: 'descendere',
    info: '',
    definitions: ['afdalen'],
    chapter: '38',
    searchForm: 'descendere',
  },
  {
    latin: 'descendi',
    info: '',
    definitions: ['*pf van* descendere'],
    chapter: '38',
    searchForm: 'descendi',
  },
  {
    latin: 'descensus',
    info: '',
    definitions: ['*ppp van* descendere'],
    chapter: '38',
    searchForm: 'descensus',
  },
  {
    latin: 'desiderare',
    info: '',
    definitions: ['verlangen (naar)'],
    chapter: '34',
    searchForm: 'desiderare',
  },
  {
    latin: 'desii',
    info: '',
    definitions: ['*pf van* desinere'],
    chapter: '54',
    searchForm: 'desii',
  },
  {
    latin: 'desinere',
    info: '',
    definitions: ['ophouden'],
    chapter: '16',
    searchForm: 'desinere',
  },
  {
    latin: 'desitus',
    info: '',
    definitions: ['*ppp van* desinere'],
    chapter: '54',
    searchForm: 'desitus',
  },
  {
    latin: 'detractus',
    info: '',
    definitions: ['*ppp van* detrahere'],
    chapter: '55',
    searchForm: 'detractus',
  },
  {
    latin: 'detrahere',
    info: '',
    definitions: ['wegnemen, afrukken'],
    chapter: '55',
    searchForm: 'detrahere',
  },
  {
    latin: 'detraxi',
    info: '',
    definitions: ['*pf van* detrahere'],
    chapter: '55',
    searchForm: 'detraxi',
  },
  {
    latin: 'deus',
    info: '',
    definitions: ['god'],
    chapter: '2',
    searchForm: 'deus',
  },
  {
    latin: 'dexter, -tra, -trum',
    info: '',
    definitions: ['rechter-, rechts'],
    chapter: '36',
    searchForm: 'dexter, -tra, -trum',
  },
  {
    latin: 'dicere',
    info: '',
    definitions: ['zeggen'],
    chapter: '2',
    searchForm: 'dicere',
  },
  {
    latin: 'dictus',
    info: '',
    definitions: ['*ppp van* dicere'],
    chapter: '34',
    searchForm: 'dictus',
  },
  {
    latin: 'didici',
    info: '',
    definitions: ['*pf van* discere'],
    chapter: '29',
    searchForm: 'didici',
  },
  {
    latin: 'dies',
    info: '5 m',
    definitions: ['dag'],
    chapter: '36',
    searchForm: 'dies',
  },
  {
    latin: 'difficilis, -e',
    info: '',
    definitions: ['moeilijk'],
    chapter: '18',
    searchForm: 'difficilis, -e',
  },
  {
    latin: 'discedere',
    info: '',
    definitions: ['weggaan'],
    chapter: '5',
    searchForm: 'discedere',
  },
  {
    latin: 'discere (a(b) + *abl*)',
    info: '',
    definitions: ['leren (van)'],
    chapter: '29',
    searchForm: 'discere (a(b) + *abl*)',
  },
  {
    latin: 'discessi',
    info: '',
    definitions: ['*pf van* discedere'],
    chapter: '47',
    searchForm: 'discessi',
  },
  {
    latin: 'discessus',
    info: '',
    definitions: ['*ppp van* discedere'],
    chapter: '47',
    searchForm: 'discessus',
  },
  {
    latin: 'diu',
    info: '',
    definitions: ['lang, lange tijd'],
    chapter: '5',
    searchForm: 'diu',
  },
  {
    latin: 'dives, divit-',
    info: '',
    definitions: ['rijk'],
    chapter: '23',
    searchForm: 'dives, divit-',
  },
  {
    latin: 'dividere',
    info: '',
    definitions: ['verdelen'],
    chapter: '3',
    searchForm: 'dividere',
  },
  {
    latin: 'divitiae',
    info: 'mv',
    definitions: ['rijkdom'],
    chapter: '29',
    searchForm: 'divitiae',
  },
  {
    latin: 'dixi',
    info: '',
    definitions: ['*pf van* dicere'],
    chapter: '12',
    searchForm: 'dixi',
  },
  {
    latin: 'docēre',
    info: '',
    definitions: ['onderwijzen'],
    chapter: '5',
    searchForm: 'docere',
  },
  {
    latin: 'doctus',
    info: '',
    definitions: ['*ppp van* docēre'],
    chapter: '33',
    searchForm: 'doctus',
  },
  {
    latin: 'docui',
    info: '',
    definitions: ['*pf van* docēre'],
    chapter: '33',
    searchForm: 'docui',
  },
  {
    latin: 'dolēre',
    info: '',
    definitions: ['treuren, pijn hebben'],
    chapter: '30',
    searchForm: 'dolere',
  },
  {
    latin: 'dolor, dolores',
    info: 'm',
    definitions: ['pijn, verdriet'],
    chapter: '24',
    searchForm: 'dolor, dolores',
  },
  {
    latin: 'dolus',
    info: '',
    definitions: ['list'],
    chapter: '22',
    searchForm: 'dolus',
  },
  {
    latin: 'domi',
    info: '',
    definitions: ['thuis'],
    chapter: '9',
    searchForm: 'domi',
  },
  {
    latin: 'dominus',
    info: '',
    definitions: ['meester, heer des huizes'],
    chapter: '13',
    searchForm: 'dominus',
  },
  {
    latin: 'domum',
    info: 'bijw',
    definitions: ['naar huis'],
    chapter: '11',
    searchForm: 'domum',
  },
  {
    latin: 'domus',
    info: '4 v',
    definitions: ['huis'],
    chapter: '13',
    searchForm: 'domus',
  },
  {
    latin: 'donec',
    info: '',
    definitions: ['totdat'],
    chapter: '24',
    searchForm: 'donec',
  },
  {
    latin: 'donum',
    info: '',
    definitions: ['geschenk'],
    chapter: '5',
    searchForm: 'donum',
  },
  {
    latin: 'dormire',
    info: '',
    definitions: ['slapen'],
    chapter: '4',
    searchForm: 'dormire',
  },
  {
    latin: 'dubitare',
    info: '',
    definitions: ['aarzelen, twijfelen'],
    chapter: '24',
    searchForm: 'dubitare',
  },
  {
    latin: 'ducere',
    info: '',
    definitions: ['leiden, brengen'],
    chapter: '12',
    searchForm: 'ducere',
  },
  {
    latin: 'ductus',
    info: '',
    definitions: ['*ppp van* ducere'],
    chapter: '33',
    searchForm: 'ductus',
  },
  {
    latin: 'dulcis, -e',
    info: '',
    definitions: ['zoet', 'lief'],
    chapter: '16',
    searchForm: 'dulcis, -e',
  },
  {
    latin: 'dum',
    info: '+ ind',
    definitions: ['terwijl', 'zolang als'],
    chapter: '3',
    searchForm: 'dum',
  },
  {
    latin: 'durus, -a, -um',
    info: '',
    definitions: ['hard'],
    chapter: '43',
    searchForm: 'durus, -a, -um',
  },
  {
    latin: 'dux, duces',
    info: 'm',
    definitions: ['aanvoerder, leider'],
    chapter: '6',
    searchForm: 'dux, duces',
  },
  {
    latin: 'duxi',
    info: '',
    definitions: ['*pf van* ducere'],
    chapter: '12',
    searchForm: 'duxi',
  },
  {
    latin: 'e',
    info: '+ abl',
    definitions: ['uit'],
    chapter: '5',
    searchForm: 'e',
  },
  {
    latin: 'ecce',
    info: '',
    definitions: ['kijk'],
    chapter: '4',
    searchForm: 'ecce',
  },
  {
    latin: 'effeci',
    info: '',
    definitions: ['*pf van* efficere'],
    chapter: '43',
    searchForm: 'effeci',
  },
  {
    latin: 'effectus',
    info: '',
    definitions: ['*ppp van* efficere'],
    chapter: '43',
    searchForm: 'effectus',
  },
  {
    latin: 'efferre',
    info: '',
    definitions: ['naar buiten dragen'],
    chapter: '40',
    searchForm: 'efferre',
  },
  {
    latin: 'efficere, efficio',
    info: '',
    definitions: ['gedaan krijgen, bereiken'],
    chapter: '43',
    searchForm: 'efficere, efficio',
  },
  {
    latin: 'effugere, effugio',
    info: '(+ acc)',
    definitions: ['wegvluchten (voor)'],
    chapter: '45',
    searchForm: 'effugere, effugio',
  },
  {
    latin: 'effugi',
    info: '',
    definitions: ['*pf van* effugere'],
    chapter: '45',
    searchForm: 'effugi',
  },
  {
    latin: 'effugitus',
    info: '',
    definitions: ['*ppp van* effugere'],
    chapter: '45',
    searchForm: 'effugitus',
  },
  {
    latin: 'egēre',
    info: '+ abl',
    definitions: ['nodig hebben'],
    chapter: '26',
    searchForm: 'egere',
  },
  {
    latin: 'egi',
    info: '',
    definitions: ['*pf van* agere'],
    chapter: '26',
    searchForm: 'egi',
  },
  {
    latin: 'egredi, egredior',
    info: '',
    definitions: ['weggaan'],
    chapter: '52',
    searchForm: 'egredi, egredior',
  },
  {
    latin: 'egressus sum',
    info: '',
    definitions: ['*pf van* egredi'],
    chapter: '52',
    searchForm: 'egressus sum',
  },
  {
    latin: 'electus',
    info: '',
    definitions: ['*ppp van* eligere'],
    chapter: '43',
    searchForm: 'electus',
  },
  {
    latin: 'elegi',
    info: '',
    definitions: ['*pf van* eligere'],
    chapter: '43',
    searchForm: 'elegi',
  },
  {
    latin: 'eligere',
    info: '',
    definitions: ['uitkiezen'],
    chapter: '43',
    searchForm: 'eligere',
  },
  {
    latin: 'emere',
    info: '',
    definitions: ['kopen'],
    chapter: '8',
    searchForm: 'emere',
  },
  {
    latin: 'emi',
    info: '',
    definitions: ['*pf van* emere'],
    chapter: '18',
    searchForm: 'emi',
  },
  {
    latin: 'enim',
    info: '',
    definitions: ['immers, want'],
    chapter: '10',
    searchForm: 'enim',
  },
  {
    latin: 'epistula',
    info: '',
    definitions: ['brief'],
    chapter: '50',
    searchForm: 'epistula',
  },
  {
    latin: 'equus',
    info: '',
    definitions: ['paard'],
    chapter: '6',
    searchForm: 'equus',
  },
  {
    latin: 'ergo',
    info: '',
    definitions: ['dus, dan'],
    chapter: '16',
    searchForm: 'ergo',
  },
  {
    latin: 'errare',
    info: '',
    definitions: ['zwerven', 'zich vergissen'],
    chapter: '55',
    searchForm: 'errare',
  },
  {
    latin: 'esse',
    info: '',
    definitions: ['zijn'],
    chapter: '2',
    searchForm: 'esse',
  },
  {
    latin: 'et',
    info: '',
    definitions: ['en', 'ook'],
    chapter: '1',
    searchForm: 'et',
  },
  {
    latin: 'etiam',
    info: '',
    definitions: ['zelfs'],
    chapter: '17',
    searchForm: 'etiam',
  },
  {
    latin: 'evadere',
    info: '',
    definitions: ['ontsnappen'],
    chapter: '44',
    searchForm: 'evadere',
  },
  {
    latin: 'evasi',
    info: '',
    definitions: ['*pf van* evadere'],
    chapter: '45',
    searchForm: 'evasi',
  },
  {
    latin: 'evasus',
    info: '',
    definitions: ['*ppp van* evadere'],
    chapter: '45',
    searchForm: 'evasus',
  },
  {
    latin: 'ex',
    info: '+ abl',
    definitions: ['uit'],
    chapter: '5',
    searchForm: 'ex',
  },
  {
    latin: 'exactus',
    info: '',
    definitions: ['*ppp van* exigere'],
    chapter: '55',
    searchForm: 'exactus',
  },
  {
    latin: 'excitare',
    info: '',
    definitions: ['(op)wekken'],
    chapter: '41',
    searchForm: 'excitare',
  },
  {
    latin: 'exclamare',
    info: '',
    definitions: ['uitroepen'],
    chapter: '44',
    searchForm: 'exclamare',
  },
  {
    latin: 'exegi',
    info: '',
    definitions: ['*pf van* exigere'],
    chapter: '55',
    searchForm: 'exegi',
  },
  {
    latin: 'exemplum',
    info: '',
    definitions: ['voorbeeld'],
    chapter: '13',
    searchForm: 'exemplum',
  },
  {
    latin: 'exercitus',
    info: '4',
    definitions: ['leger'],
    chapter: '36',
    searchForm: 'exercitus',
  },
  {
    latin: 'exigere',
    info: '',
    definitions: ['verdrijven', '(op)eisen'],
    chapter: '55',
    searchForm: 'exigere',
  },
  {
    latin: 'exii',
    info: '',
    definitions: ['*pf van* exire'],
    chapter: '17',
    searchForm: 'exii',
  },
  {
    latin: 'exilium',
    info: '',
    definitions: ['verbanning, ballingschap'],
    chapter: '54',
    searchForm: 'exilium',
  },
  {
    latin: 'exire',
    info: '',
    definitions: ['naar buiten gaan'],
    chapter: '17',
    searchForm: 'exire',
  },
  {
    latin: 'exitium',
    info: '',
    definitions: ['ondergang'],
    chapter: '45',
    searchForm: 'exitium',
  },
  {
    latin: 'exiturus',
    info: '',
    definitions: ['*pfa van* exire'],
    chapter: '32',
    searchForm: 'exiturus',
  },
  {
    latin: 'exitus',
    info: '4',
    definitions: ['uitgang', 'afloop'],
    chapter: '38',
    searchForm: 'exitus',
  },
  {
    latin: 'expellere',
    info: '',
    definitions: ['verdrijven'],
    chapter: '55',
    searchForm: 'expellere',
  },
  {
    latin: 'experiri',
    info: '',
    definitions: ['beproeven'],
    chapter: '50',
    searchForm: 'experiri',
  },
  {
    latin: 'expertus sum',
    info: '',
    definitions: ['*pf van* experiri'],
    chapter: '50',
    searchForm: 'expertus sum',
  },
  {
    latin: 'expugnare',
    info: '',
    definitions: ['veroveren'],
    chapter: '29',
    searchForm: 'expugnare',
  },
  {
    latin: 'expuli',
    info: '',
    definitions: ['*pf van* expellere'],
    chapter: '55',
    searchForm: 'expuli',
  },
  {
    latin: 'expulsus',
    info: '',
    definitions: ['*ppp van* expellere'],
    chapter: '55',
    searchForm: 'expulsus',
  },
  {
    latin: 'exspectare',
    info: '',
    definitions: ['wachten (op)'],
    chapter: '6',
    searchForm: 'exspectare',
  },
  {
    latin: 'exstinguere',
    info: '',
    definitions: ['blussen'],
    chapter: '45',
    searchForm: 'exstinguere',
  },
  {
    latin: 'extra',
    info: '+ acc',
    definitions: ['buiten'],
    chapter: '48',
    searchForm: 'extra',
  },
  {
    latin: 'extra',
    info: 'bijw',
    definitions: ['buiten'],
    chapter: '48',
    searchForm: 'extra',
  },
  {
    latin: 'fabula',
    info: '',
    definitions: ['verhaal'],
    chapter: '13',
    searchForm: 'fabula',
  },
  {
    latin: 'facere, facio',
    info: '',
    definitions: ['doen', 'maken'],
    chapter: '3',
    searchForm: 'facere, facio',
  },
  {
    latin: 'facies',
    info: '5',
    definitions: ['gezicht, gedaante'],
    chapter: '40',
    searchForm: 'facies',
  },
  {
    latin: 'facilis, -e',
    info: '',
    definitions: ['gemakkelijk'],
    chapter: '18',
    searchForm: 'facilis, -e',
  },
  {
    latin: 'facinus, facinora',
    info: '',
    definitions: ['daad', 'misdaad'],
    chapter: '54',
    searchForm: 'facinus, facinora',
  },
  {
    latin: 'factus',
    info: '',
    definitions: ['*ppp van* facere'],
    chapter: '33',
    searchForm: 'factus',
  },
  {
    latin: 'factus sum',
    info: '',
    definitions: ['*pf van* fieri'],
    chapter: '50',
    searchForm: 'factus sum',
  },
  {
    latin: 'fallere',
    info: '',
    definitions: ['bedriegen', 'ontgaan'],
    chapter: '55',
    searchForm: 'fallere',
  },
  {
    latin: 'falsus',
    info: '',
    definitions: ['*ppp van* fallere'],
    chapter: '55',
    searchForm: 'falsus',
  },
  {
    latin: 'falsus, -a, -um',
    info: '',
    definitions: ['onwaar, ongegrond'],
    chapter: '34',
    searchForm: 'falsus, -a, -um',
  },
  {
    latin: 'fama',
    info: '',
    definitions: ['gerucht', 'goede naam', 'slechte naam'],
    chapter: '45',
    searchForm: 'fama',
  },
  {
    latin: 'fames, fames',
    info: 'v',
    definitions: ['honger'],
    chapter: '46',
    searchForm: 'fames, fames',
  },
  {
    latin: 'familia',
    info: '',
    definitions: ['familie, huishouden'],
    chapter: '16',
    searchForm: 'familia',
  },
  {
    latin: 'favēre',
    info: '+ dat',
    definitions: ['steun geven aan'],
    chapter: '2',
    searchForm: 'favere',
  },
  {
    latin: 'feci',
    info: '',
    definitions: ['*pf van* facere'],
    chapter: '12',
    searchForm: 'feci',
  },
  {
    latin: 'fefelli',
    info: '',
    definitions: ['*pf van* fallere'],
    chapter: '55',
    searchForm: 'fefelli',
  },
  {
    latin: 'felix, felic-',
    info: '',
    definitions: ['gelukkig'],
    chapter: '17',
    searchForm: 'felix, felic-',
  },
  {
    latin: 'femina',
    info: '',
    definitions: ['vrouw'],
    chapter: '2',
    searchForm: 'femina',
  },
  {
    latin: 'ferox, feroc-',
    info: '',
    definitions: ['woest, onstuimig'],
    chapter: '19',
    searchForm: 'ferox, feroc-',
  },
  {
    latin: 'ferre',
    info: '',
    definitions: ['dragen, brengen', 'verdragen'],
    chapter: '32',
    searchForm: 'ferre',
  },
  {
    latin: 'fides',
    info: '5',
    definitions: ['(woord van) trouw', 'vertrouwen'],
    chapter: '38',
    searchForm: 'fides',
  },
  {
    latin: 'fidus, -a, -um',
    info: '',
    definitions: ['trouw', 'betrouwbaar'],
    chapter: '18',
    searchForm: 'fidus, -a, -um',
  },
  {
    latin: 'fieri',
    info: '',
    definitions: ['(gemaakt) worden', 'gebeuren'],
    chapter: '50',
    searchForm: 'fieri',
  },
  {
    latin: 'filia',
    info: '',
    definitions: ['dochter'],
    chapter: '8',
    searchForm: 'filia',
  },
  {
    latin: 'filius',
    info: '',
    definitions: ['zoon'],
    chapter: '2',
    searchForm: 'filius',
  },
  {
    latin: 'finire',
    info: '',
    definitions: ['beëindigen'],
    chapter: '9',
    searchForm: 'finire',
  },
  {
    latin: 'finis, fines',
    info: 'm',
    definitions: ['grens, einde', '**mv** gebied'],
    chapter: '26',
    searchForm: 'finis, fines',
  },
  {
    latin: 'flamma',
    info: '',
    definitions: ['vlam'],
    chapter: '45',
    searchForm: 'flamma',
  },
  {
    latin: 'fluctus',
    info: '4',
    definitions: ['golf'],
    chapter: '53',
    searchForm: 'fluctus',
  },
  {
    latin: 'fluere',
    info: '',
    definitions: ['stromen'],
    chapter: '9',
    searchForm: 'fluere',
  },
  {
    latin: 'flumen, flumina',
    info: '',
    definitions: ['rivier'],
    chapter: '1',
    searchForm: 'flumen, flumina',
  },
  {
    latin: 'fons, fontes',
    info: 'v',
    definitions: ['bron'],
    chapter: '51',
    searchForm: 'fons, fontes',
  },
  {
    latin: 'forma',
    info: '',
    definitions: ['gestalte, schoonheid'],
    chapter: '23',
    searchForm: 'forma',
  },
  {
    latin: 'fortasse',
    info: '',
    definitions: ['misschien'],
    chapter: '8',
    searchForm: 'fortasse',
  },
  {
    latin: 'fortis, -e',
    info: '',
    definitions: ['dapper', 'sterk'],
    chapter: '16',
    searchForm: 'fortis, -e',
  },
  {
    latin: 'forum',
    info: '',
    definitions: ['forum, marktplaats'],
    chapter: '6',
    searchForm: 'forum',
  },
  {
    latin: 'fractus',
    info: '',
    definitions: ['*ppp van* frangere'],
    chapter: '29, 54',
    searchForm: 'fractus',
  },
  {
    latin: 'frangere',
    info: '',
    definitions: ['breken'],
    chapter: '29',
    searchForm: 'frangere',
  },
  {
    latin: 'frater, fratres',
    info: 'm',
    definitions: ['broer'],
    chapter: '3',
    searchForm: 'frater, fratres',
  },
  {
    latin: 'fregi',
    info: '',
    definitions: ['*pf van* frangere'],
    chapter: '29, 54',
    searchForm: 'fregi',
  },
  {
    latin: 'frequens, frequent-',
    info: '',
    definitions: ['herhaaldelijk'],
    chapter: '27',
    searchForm: 'frequens, frequent-',
  },
  {
    latin: 'fructus sum',
    info: '',
    definitions: ['*pf van* frui'],
    chapter: '50',
    searchForm: 'fructus sum',
  },
  {
    latin: 'frui',
    info: '+ abl',
    definitions: ['genieten van'],
    chapter: '51',
    searchForm: 'frui',
  },
  {
    latin: 'frumentum',
    info: '',
    definitions: ['graan'],
    chapter: '26',
    searchForm: 'frumentum',
  },
  {
    latin: 'frustra',
    info: '',
    definitions: ['tevergeefs'],
    chapter: '10',
    searchForm: 'frustra',
  },
  {
    latin: 'fuga',
    info: '',
    definitions: ['vlucht'],
    chapter: '20',
    searchForm: 'fuga',
  },
  {
    latin: 'fugere, fugio',
    info: '',
    definitions: ['vluchten', '**+ acc** ontvluchten'],
    chapter: '6, 19',
    searchForm: 'fugere, fugio',
  },
  {
    latin: 'fugi',
    info: '',
    definitions: ['*pf van* fugere'],
    chapter: '13',
    searchForm: 'fugi',
  },
  {
    latin: 'fui',
    info: '',
    definitions: ['*pf van* esse'],
    chapter: '12',
    searchForm: 'fui',
  },
  {
    latin: 'functus sum',
    info: '',
    definitions: ['*pf van* fungi'],
    chapter: '50',
    searchForm: 'functus sum',
  },
  {
    latin: 'fundere',
    info: '',
    definitions: ['gieten, storten'],
    chapter: '25',
    searchForm: 'fundere',
  },
  {
    latin: 'fungi',
    info: '+ abl',
    definitions: ['verrichten, vervullen'],
    chapter: '50',
    searchForm: 'fungi',
  },
  {
    latin: 'funus, funera',
    info: '',
    definitions: ['begrafenis'],
    chapter: '17',
    searchForm: 'funus, funera',
  },
  {
    latin: 'furere',
    info: '',
    definitions: ['tekeer gaan'],
    chapter: '53',
    searchForm: 'furere',
  },
  {
    latin: 'futurum',
    info: '',
    definitions: ['*pfa van* esse'],
    chapter: '33',
    searchForm: 'futurum',
  },
  {
    latin: 'gaudēre',
    info: '',
    definitions: ['blij zijn'],
    chapter: '9',
    searchForm: 'gaudere',
  },
  {
    latin: 'gaudium',
    info: '',
    definitions: ['vreugde'],
    chapter: '16',
    searchForm: 'gaudium',
  },
  {
    latin: 'gavisus sum',
    info: '',
    definitions: ['*pf van* gaudēre'],
    chapter: '50',
    searchForm: 'gavisus sum',
  },
  {
    latin: 'gens, gentes',
    info: 'v',
    definitions: ['volk, stam', 'geslacht'],
    chapter: '37',
    searchForm: 'gens, gentes',
  },
  {
    latin: 'genu, genua',
    info: '',
    definitions: ['knie'],
    chapter: '44',
    searchForm: 'genu, genua',
  },
  {
    latin: 'gerere',
    info: '',
    definitions: ['dragen', 'voeren'],
    chapter: '6',
    searchForm: 'gerere',
  },
  {
    latin: 'gladius',
    info: '',
    definitions: ['zwaard'],
    chapter: '3',
    searchForm: 'gladius',
  },
  {
    latin: 'gloria',
    info: '',
    definitions: ['roem'],
    chapter: '34',
    searchForm: 'gloria',
  },
  {
    latin: 'gradus',
    info: '4',
    definitions: ['stap, trede'],
    chapter: '36',
    searchForm: 'gradus',
  },
  {
    latin: 'Graecus',
    info: '',
    definitions: ['Griek'],
    chapter: '43',
    searchForm: 'Graecus',
  },
  {
    latin: 'Graecus, -a, -um',
    info: '',
    definitions: ['Grieks'],
    chapter: '43',
    searchForm: 'Graecus, -a, -um',
  },
  {
    latin: 'gratia',
    info: '',
    definitions: ['gunst', 'charme', 'dank'],
    chapter: '44',
    searchForm: 'gratia',
  },
  {
    latin: 'gratias agere',
    info: '',
    definitions: ['dank betuigen'],
    chapter: '46',
    searchForm: 'gratias agere',
  },
  {
    latin: 'gravis, -e',
    info: '',
    definitions: ['zwaar, ernstig'],
    chapter: '18',
    searchForm: 'gravis, -e',
  },
  {
    latin: 'habēre',
    info: '',
    definitions: ['hebben', 'houden'],
    chapter: '8, 30',
    searchForm: 'habere',
  },
  {
    latin: 'habitare',
    info: '',
    definitions: ['(be)wonen'],
    chapter: '13',
    searchForm: 'habitare',
  },
  {
    latin: 'haerēre',
    info: '',
    definitions: ['blijven steken'],
    chapter: '36',
    searchForm: 'haerere',
  },
  {
    latin: 'haud',
    info: '',
    definitions: ['helemaal niet'],
    chapter: '2',
    searchForm: 'haud',
  },
  {
    latin: 'heri',
    info: '',
    definitions: ['gisteren'],
    chapter: '12',
    searchForm: 'heri',
  },
  {
    latin: 'hic',
    info: 'bijw',
    definitions: ['hier'],
    chapter: '8',
    searchForm: 'hic',
  },
  {
    latin: 'hic, haec, hoc',
    info: '',
    definitions: ['deze, dit'],
    chapter: '40',
    searchForm: 'hic, haec, hoc',
  },
  {
    latin: 'hiems, hiemes',
    info: 'v',
    definitions: ['winter'],
    chapter: '53',
    searchForm: 'hiems, hiemes',
  },
  {
    latin: 'hinc',
    info: '',
    definitions: ['hiervandaan'],
    chapter: '45',
    searchForm: 'hinc',
  },
  {
    latin: 'hodie',
    info: '',
    definitions: ['vandaag'],
    chapter: '9',
    searchForm: 'hodie',
  },
  {
    latin: 'homo, homines',
    info: 'm',
    definitions: ['mens, man'],
    chapter: '10',
    searchForm: 'homo, homines',
  },
  {
    latin: 'honor, honores',
    info: 'm',
    definitions: ['eer', '(ere)ambt'],
    chapter: '34',
    searchForm: 'honor, honores',
  },
  {
    latin: 'hora',
    info: '',
    definitions: ['uur'],
    chapter: '11',
    searchForm: 'hora',
  },
  {
    latin: 'hortari',
    info: '',
    definitions: ['aansporen'],
    chapter: '50',
    searchForm: 'hortari',
  },
  {
    latin: 'hospes, hospites',
    info: 'm',
    definitions: ['gast'],
    chapter: '13',
    searchForm: 'hospes, hospites',
  },
  {
    latin: 'hostis, hostes',
    info: 'm',
    definitions: ['vijand'],
    chapter: '3',
    searchForm: 'hostis, hostes',
  },
  {
    latin: 'humilis, -e',
    info: '',
    definitions: ['laag', 'nederig'],
    chapter: '18',
    searchForm: 'humilis, -e',
  },
  {
    latin: 'iacēre',
    info: '',
    definitions: ['liggen'],
    chapter: '1',
    searchForm: 'iacere',
  },
  {
    latin: 'iacere, iacio',
    info: '',
    definitions: ['werpen'],
    chapter: '36',
    searchForm: 'iacere, iacio',
  },
  {
    latin: 'iactare',
    info: '',
    definitions: ['slingeren', 'opscheppen over'],
    chapter: '44',
    searchForm: 'iactare',
  },
  {
    latin: 'iactus',
    info: '',
    definitions: ['*ppp van* iacere'],
    chapter: '39',
    searchForm: 'iactus',
  },
  {
    latin: 'iam',
    info: '',
    definitions: ['al, reeds'],
    chapter: '3',
    searchForm: 'iam',
  },
  {
    latin: 'ibi',
    info: '',
    definitions: ['daar'],
    chapter: '1',
    searchForm: 'ibi',
  },
  {
    latin: 'id',
    info: 'nom/acc',
    definitions: ['dit'],
    chapter: '11',
    searchForm: 'id',
  },
  {
    latin: 'idem, eadem, idem',
    info: '',
    definitions: ['dezelfde, hetzelfde'],
    chapter: '40',
    searchForm: 'idem, eadem, idem',
  },
  {
    latin: 'ideo',
    info: '',
    definitions: ['daarom'],
    chapter: '1',
    searchForm: 'ideo',
  },
  {
    latin: 'ieci',
    info: '',
    definitions: ['*pf van* iacere'],
    chapter: '39',
    searchForm: 'ieci',
  },
  {
    latin: 'igitur',
    info: '',
    definitions: ['dus'],
    chapter: '47',
    searchForm: 'igitur',
  },
  {
    latin: 'ignis, ignes',
    info: 'm',
    definitions: ['vuur'],
    chapter: '5',
    searchForm: 'ignis, ignes',
  },
  {
    latin: 'ignoscere',
    info: '+ dat',
    definitions: ['vergeven'],
    chapter: '52',
    searchForm: 'ignoscere',
  },
  {
    latin: 'ignotus, -a, -um',
    info: '',
    definitions: ['onbekend'],
    chapter: '26',
    searchForm: 'ignotus, -a, -um',
  },
  {
    latin: 'ii',
    info: '',
    definitions: ['*pf van* ire'],
    chapter: '17',
    searchForm: 'ii',
  },
  {
    latin: 'ille, illa, illud',
    info: '',
    definitions: ['die, dat'],
    chapter: '40',
    searchForm: 'ille, illa, illud',
  },
  {
    latin: 'illustris, -e',
    info: '',
    definitions: ['aanzienlijk, beroemd'],
    chapter: '16',
    searchForm: 'illustris, -e',
  },
  {
    latin: 'imago, imagines',
    info: 'v',
    definitions: ['beeld, afbeelding'],
    chapter: '24',
    searchForm: 'imago, imagines',
  },
  {
    latin: 'immensus, -a, -um',
    info: '',
    definitions: ['onmetelijk'],
    chapter: '46',
    searchForm: 'immensus, -a, -um',
  },
  {
    latin: 'imminēre',
    info: '+ dat',
    definitions: ['(be)dreigen'],
    chapter: '39',
    searchForm: 'imminere',
  },
  {
    latin: 'immo',
    info: '',
    definitions: ['integendeel'],
    chapter: '8',
    searchForm: 'immo',
  },
  {
    latin: 'impedire',
    info: '',
    definitions: ['belemmeren, verhinderen'],
    chapter: '36',
    searchForm: 'impedire',
  },
  {
    latin: 'imperare',
    info: '',
    definitions: ['bevelen, opdragen'],
    chapter: '54',
    searchForm: 'imperare',
  },
  {
    latin: 'imperator, -ores',
    info: 'm',
    definitions: ['opperbevelhebber', 'keizer'],
    chapter: '38',
    searchForm: 'imperator, -ores',
  },
  {
    latin: 'imperium',
    info: '',
    definitions: ['bevel, gezag', 'heerschappij, rijk'],
    chapter: '38',
    searchForm: 'imperium',
  },
  {
    latin: 'impetus',
    info: '4',
    definitions: ['het aanstormen', 'aanval'],
    chapter: '36',
    searchForm: 'impetus',
  },
  {
    latin: 'imponere',
    info: '',
    definitions: ['plaatsen op, opleggen'],
    chapter: '46',
    searchForm: 'imponere',
  },
  {
    latin: 'improbus, -a, -um',
    info: '',
    definitions: ['slecht, gemeen'],
    chapter: '43',
    searchForm: 'improbus, -a, -um',
  },
  {
    latin: 'in',
    info: '+ abl',
    definitions: ['in', 'op'],
    chapter: '3',
    searchForm: 'in',
  },
  {
    latin: 'in',
    info: '+ acc',
    definitions: ['in, naar'],
    chapter: '1',
    searchForm: 'in',
  },
  {
    latin: 'inanis, -e',
    info: '',
    definitions: ['leeg, zinloos'],
    chapter: '39',
    searchForm: 'inanis, -e',
  },
  {
    latin: 'incendium',
    info: '',
    definitions: ['brand'],
    chapter: '45',
    searchForm: 'incendium',
  },
  {
    latin: 'incepi',
    info: '',
    definitions: ['*pf van* incipere'],
    chapter: '12',
    searchForm: 'incepi',
  },
  {
    latin: 'inceptus',
    info: '',
    definitions: ['*ppp van* incipere'],
    chapter: '32',
    searchForm: 'inceptus',
  },
  {
    latin: 'incertus, -a, -um',
    info: '',
    definitions: ['onzeker'],
    chapter: '53',
    searchForm: 'incertus, -a, -um',
  },
  {
    latin: 'incipere, incipio',
    info: '',
    definitions: ['beginnen'],
    chapter: '8',
    searchForm: 'incipere, incipio',
  },
  {
    latin: 'includere',
    info: '',
    definitions: ['insluiten'],
    chapter: '40',
    searchForm: 'includere',
  },
  {
    latin: 'inclusi',
    info: '',
    definitions: ['*pf van* includere'],
    chapter: '40',
    searchForm: 'inclusi',
  },
  {
    latin: 'inclusus',
    info: '',
    definitions: ['*ppp van* includere'],
    chapter: '40',
    searchForm: 'inclusus',
  },
  {
    latin: 'ingenium',
    info: '',
    definitions: ['karakter', 'aanleg'],
    chapter: '47',
    searchForm: 'ingenium',
  },
  {
    latin: 'ingens, ingent-',
    info: '',
    definitions: ['enorm, geweldig'],
    chapter: '16',
    searchForm: 'ingens, ingent-',
  },
  {
    latin: 'inii',
    info: '',
    definitions: ['*pf van* inire'],
    chapter: '38',
    searchForm: 'inii',
  },
  {
    latin: 'inimicus',
    info: '',
    definitions: ['vijand'],
    chapter: '39',
    searchForm: 'inimicus',
  },
  {
    latin: 'inimicus, -a, -um',
    info: '',
    definitions: ['vijandig'],
    chapter: '39',
    searchForm: 'inimicus, -a, -um',
  },
  {
    latin: 'inire',
    info: '',
    definitions: ['ingaan', 'beginnen'],
    chapter: '38',
    searchForm: 'inire',
  },
  {
    latin: 'initium',
    info: '',
    definitions: ['begin'],
    chapter: '8',
    searchForm: 'initium',
  },
  {
    latin: 'initurus',
    info: '',
    definitions: ['*pfa van* inire'],
    chapter: '38',
    searchForm: 'initurus',
  },
  {
    latin: 'iniuria',
    info: '',
    definitions: ['onrecht'],
    chapter: '12',
    searchForm: 'iniuria',
  },
  {
    latin: 'incolumis, -e',
    info: '',
    definitions: ['ongedeerd'],
    chapter: '36',
    searchForm: 'incolumis, -e',
  },
  {
    latin: 'inopia',
    info: '',
    definitions: ['gebrek, armoede'],
    chapter: '46',
    searchForm: 'inopia',
  },
  {
    latin: 'inquit',
    info: '',
    definitions: ['hij/zij zegt', 'hij/zij zei'],
    chapter: '24',
    searchForm: 'inquit',
  },
  {
    latin: 'insignis, -e',
    info: '',
    definitions: ['opvallend'],
    chapter: '40',
    searchForm: 'insignis, -e',
  },
  {
    latin: 'instare',
    info: '+ dat',
    definitions: ['achterna zitten'],
    chapter: '36',
    searchForm: 'instare',
  },
  {
    latin: 'instituere',
    info: '',
    definitions: ['oprichten'],
    chapter: '47',
    searchForm: 'instituere',
  },
  {
    latin: 'instructus',
    info: '',
    definitions: ['*ppp van* instruere'],
    chapter: '31',
    searchForm: 'instructus',
  },
  {
    latin: 'instruere',
    info: '',
    definitions: ['opstellen'],
    chapter: '31',
    searchForm: 'instruere',
  },
  {
    latin: 'instruxi',
    info: '',
    definitions: ['*pf van* instruere'],
    chapter: '31',
    searchForm: 'instruxi',
  },
  {
    latin: 'insula',
    info: '',
    definitions: ['eiland'],
    chapter: '55',
    searchForm: 'insula',
  },
  {
    latin: 'intellegere',
    info: '',
    definitions: ['begrijpen'],
    chapter: '23',
    searchForm: 'intellegere',
  },
  {
    latin: 'intellexi',
    info: '',
    definitions: ['*pf van* intellegere'],
    chapter: '25',
    searchForm: 'intellexi',
  },
  {
    latin: 'intendere',
    info: '',
    definitions: ['richten'],
    chapter: '30',
    searchForm: 'intendere',
  },
  {
    latin: 'inter',
    info: '+ acc',
    definitions: ['tussen', 'tijdens'],
    chapter: '1',
    searchForm: 'inter',
  },
  {
    latin: 'inter se',
    info: '',
    definitions: ['onderling'],
    chapter: '44',
    searchForm: 'inter se',
  },
  {
    latin: 'interea',
    info: '',
    definitions: ['intussen'],
    chapter: '6',
    searchForm: 'interea',
  },
  {
    latin: 'interest',
    info: '',
    definitions: ['het is van belang'],
    chapter: '41',
    searchForm: 'interest',
  },
  {
    latin: 'interfeci',
    info: '',
    definitions: ['*pf van* interficere'],
    chapter: '33',
    searchForm: 'interfeci',
  },
  {
    latin: 'interfectus',
    info: '',
    definitions: ['*ppp van* interficere'],
    chapter: '31',
    searchForm: 'interfectus',
  },
  {
    latin: 'interficere, -ficio',
    info: '',
    definitions: ['doden'],
    chapter: '31',
    searchForm: 'interficere, -ficio',
  },
  {
    latin: 'interii',
    info: '',
    definitions: ['*pf van* interire'],
    chapter: '41',
    searchForm: 'interii',
  },
  {
    latin: 'interire',
    info: '',
    definitions: ['omkomen, sterven'],
    chapter: '41',
    searchForm: 'interire',
  },
  {
    latin: 'interiturus',
    info: '',
    definitions: ['*pfa van* interire'],
    chapter: '41',
    searchForm: 'interiturus',
  },
  {
    latin: 'intra',
    info: '+ acc',
    definitions: ['binnen'],
    chapter: '38',
    searchForm: 'intra',
  },
  {
    latin: 'intrare',
    info: '',
    definitions: ['binnenkomen'],
    chapter: '3',
    searchForm: 'intrare',
  },
  {
    latin: 'invadere',
    info: '',
    definitions: ['binnendringen, aanvallen'],
    chapter: '36',
    searchForm: 'invadere',
  },
  {
    latin: 'invasi',
    info: '',
    definitions: ['*pf van* invadere'],
    chapter: '41',
    searchForm: 'invasi',
  },
  {
    latin: 'invasus',
    info: '',
    definitions: ['*ppp van* invadere'],
    chapter: '41',
    searchForm: 'invasus',
  },
  {
    latin: 'inveni',
    info: '',
    definitions: ['*pf van* invenire'],
    chapter: '17',
    searchForm: 'inveni',
  },
  {
    latin: 'invenire',
    info: '',
    definitions: ['vinden', 'uitvinden'],
    chapter: '17, 33',
    searchForm: 'invenire',
  },
  {
    latin: 'inventus',
    info: '',
    definitions: ['*ppp van* invenire'],
    chapter: '33',
    searchForm: 'inventus',
  },
  {
    latin: 'invitare',
    info: '',
    definitions: ['uitnodigen'],
    chapter: '16',
    searchForm: 'invitare',
  },
  {
    latin: 'Iovis',
    info: '',
    definitions: ['*gen van* Iupiter'],
    chapter: '27',
    searchForm: 'Iovis',
  },
  {
    latin: 'ipse, ipsa, ipsum',
    info: '',
    definitions: ['zelf'],
    chapter: '22',
    searchForm: 'ipse, ipsa, ipsum',
  },
  {
    latin: 'ira',
    info: '',
    definitions: ['woede'],
    chapter: '33',
    searchForm: 'ira',
  },
  {
    latin: 'iratus, -a, -um',
    info: '',
    definitions: ['boos'],
    chapter: '17',
    searchForm: 'iratus, -a, -um',
  },
  {
    latin: 'ire',
    info: '',
    definitions: ['gaan'],
    chapter: '11',
    searchForm: 'ire',
  },
  {
    latin: 'is, ea, id',
    info: '',
    definitions: ['*bnw* deze/dit, die/dat', '*znw* hij, zij, het'],
    chapter: '40',
    searchForm: 'iste, ista, istud',
  },
  {
    latin: 'iste, ista, istud',
    info: '',
    definitions: ['die, dat'],
    chapter: '40',
    searchForm: 'iste, ista, istud',
  },
  {
    latin: 'ita',
    info: '',
    definitions: ['zo'],
    chapter: '9',
    searchForm: 'ita',
  },
  {
    latin: 'itaque',
    info: '',
    definitions: ['dus'],
    chapter: '45',
    searchForm: 'itaque',
  },
  {
    latin: 'iter, itinera',
    info: '',
    definitions: ['reis'],
    chapter: '13',
    searchForm: 'iter, itinera',
  },
  {
    latin: 'iterum',
    info: '',
    definitions: ['weer, opnieuw'],
    chapter: '9',
    searchForm: 'iterum',
  },
  {
    latin: 'iturus',
    info: '',
    definitions: ['*pfa van* ire'],
    chapter: '32',
    searchForm: 'iturus',
  },
  {
    latin: 'iubēre',
    info: '',
    definitions: ['bevelen'],
    chapter: '1',
    searchForm: 'iubere',
  },
  {
    latin: 'iungere',
    info: '',
    definitions: ['verbinden'],
    chapter: '41',
    searchForm: 'iungere',
  },
  {
    latin: 'iurare (per + *acc*)',
    info: '',
    definitions: ['zweren (bij)'],
    chapter: '29',
    searchForm: 'iurare (per + *acc*)',
  },
  {
    latin: 'iussi',
    info: '',
    definitions: ['*pf van* iubēre'],
    chapter: '18',
    searchForm: 'iussi',
  },
  {
    latin: 'iutus',
    info: '',
    definitions: ['*ppp van* iuvare'],
    chapter: '40',
    searchForm: 'iutus',
  },
  {
    latin: 'iuvare',
    info: '',
    definitions: ['helpen'],
    chapter: '40',
    searchForm: 'iuvare',
  },
  {
    latin: 'iuvat (me)',
    info: '',
    definitions: ['het doet (me) plezier'],
    chapter: '23',
    searchForm: 'iuvat (me)',
  },
  {
    latin: 'iuvenis, iuvenes',
    info: 'm',
    definitions: ['jongeman'],
    chapter: '24',
    searchForm: 'iuvenis, iuvenes',
  },
  {
    latin: 'iuventus, -tutes',
    info: 'v',
    definitions: ['jeugd'],
    chapter: '26',
    searchForm: 'iuventus, -tutes',
  },
  {
    latin: 'iuvi',
    info: '',
    definitions: ['*pf van* iuvare'],
    chapter: '40',
    searchForm: 'iuvi',
  },
  {
    latin: 'labor, labores',
    info: 'm',
    definitions: ['werk, inspanning'],
    chapter: '25',
    searchForm: 'labor, labores',
  },
  {
    latin: 'laborare',
    info: '',
    definitions: ['hard werken'],
    chapter: '23',
    searchForm: 'laborare',
  },
  {
    latin: 'lacrima',
    info: '',
    definitions: ['traan'],
    chapter: '52',
    searchForm: 'lacrima',
  },
  {
    latin: 'lacrimare',
    info: '',
    definitions: ['huilen'],
    chapter: '1',
    searchForm: 'lacrimare',
  },
  {
    latin: 'laedere',
    info: '',
    definitions: ['beledigen, kwetsen'],
    chapter: '25',
    searchForm: 'laedere',
  },
  {
    latin: 'laesi',
    info: '',
    definitions: ['*pf van* laedere'],
    chapter: '25',
    searchForm: 'laesi',
  },
  {
    latin: 'laetus, -a, -um',
    info: '',
    definitions: ['blij'],
    chapter: '15',
    searchForm: 'laetus, -a, -um',
  },
  {
    latin: 'lapis, lapides',
    info: 'm',
    definitions: ['steen(soort)'],
    chapter: '51',
    searchForm: 'lapis, lapides',
  },
  {
    latin: 'latēre',
    info: '',
    definitions: ['verborgen zijn'],
    chapter: '53',
    searchForm: 'latere',
  },
  {
    latin: 'latus',
    info: '',
    definitions: ['*ppp van* ferre'],
    chapter: '32',
    searchForm: 'latus',
  },
  {
    latin: 'latus, -a, -um',
    info: '',
    definitions: ['breed, wijd'],
    chapter: '31',
    searchForm: 'latus, -a, -um',
  },
  {
    latin: 'laudare',
    info: '',
    definitions: ['prijzen'],
    chapter: '22',
    searchForm: 'laudare',
  },
  {
    latin: 'laus, laudes',
    info: 'v',
    definitions: ['lof, roem'],
    chapter: '31',
    searchForm: 'laus, laudes',
  },
  {
    latin: 'lavare',
    info: '',
    definitions: ['wassen'],
    chapter: '25',
    searchForm: 'lavare',
  },
  {
    latin: 'legatus',
    info: '',
    definitions: ['gezant', 'onderbevelhebber'],
    chapter: '38, 48',
    searchForm: 'legatus',
  },
  {
    latin: 'legere',
    info: '',
    definitions: ['lezen'],
    chapter: '18',
    searchForm: 'legere',
  },
  {
    latin: 'legio, legiones',
    info: 'v',
    definitions: ['legioen'],
    chapter: '20',
    searchForm: 'legio, legiones',
  },
  {
    latin: 'lenis, -e',
    info: '',
    definitions: ['mild, zacht'],
    chapter: '17',
    searchForm: 'lenis, -e',
  },
  {
    latin: 'lentus, -a, -um',
    info: '',
    definitions: ['traag'],
    chapter: '19',
    searchForm: 'lentus, -a, -um',
  },
  {
    latin: 'leo, leones',
    info: 'm',
    definitions: ['leeuw'],
    chapter: '10',
    searchForm: 'leo, leones',
  },
  {
    latin: 'lex, leges',
    info: 'v',
    definitions: ['wet'],
    chapter: '52',
    searchForm: 'lex, leges',
  },
  {
    latin: 'libenter',
    info: '',
    definitions: ['graag'],
    chapter: '23',
    searchForm: 'libenter',
  },
  {
    latin: 'liberare (a + *abl*)',
    info: '',
    definitions: ['bevrijden (van)'],
    chapter: '40',
    searchForm: 'liberare (a + *abl*)',
  },
  {
    latin: 'liberi',
    info: 'mv',
    definitions: ['kinderen'],
    chapter: '15',
    searchForm: 'liberi',
  },
  {
    latin: 'libertas, libertates',
    info: 'v',
    definitions: ['vrijheid'],
    chapter: '19',
    searchForm: 'libertas, libertates',
  },
  {
    latin: 'licet',
    info: '(+ dat)',
    definitions: ['het is toegestaan (aan)'],
    chapter: '3',
    searchForm: 'licet',
  },
  {
    latin: 'lingua',
    info: '',
    definitions: ['tong', 'taal'],
    chapter: '19',
    searchForm: 'lingua',
  },
  {
    latin: 'littera',
    info: '',
    definitions: ['letter'],
    chapter: '18',
    searchForm: 'littera',
  },
  {
    latin: 'litus, litora',
    info: '',
    definitions: ['kust'],
    chapter: '20',
    searchForm: 'litus, litora',
  },
  {
    latin: 'locus',
    info: '',
    definitions: ['plaats'],
    chapter: '1',
    searchForm: 'locus',
  },
  {
    latin: 'locutus sum',
    info: '',
    definitions: ['*pf van* loqui'],
    chapter: '50',
    searchForm: 'locutus sum',
  },
  {
    latin: 'longe',
    info: 'bijw',
    definitions: ['ver (weg), verreweg'],
    chapter: '10',
    searchForm: 'longe',
  },
  {
    latin: 'longus, -a, -um',
    info: '',
    definitions: ['lang'],
    chapter: '15',
    searchForm: 'longus, -a, -um',
  },
  {
    latin: 'loqui',
    info: '',
    definitions: ['spreken'],
    chapter: '50',
    searchForm: 'loqui',
  },
  {
    latin: 'ludere',
    info: '',
    definitions: ['spelen'],
    chapter: '5',
    searchForm: 'ludere',
  },
  {
    latin: 'lumen, lumina',
    info: '',
    definitions: ['licht', 'lamp'],
    chapter: '33',
    searchForm: 'lumen, lumina',
  },
  {
    latin: 'lux, luces',
    info: 'v',
    definitions: ['(dag)licht'],
    chapter: '34',
    searchForm: 'lux, luces',
  },
  {
    latin: 'luxuria',
    info: '',
    definitions: ['(zucht naar) weelde'],
    chapter: '39',
    searchForm: 'luxuria',
  },
  {
    latin: 'magis',
    info: '',
    definitions: ['meer'],
    chapter: '18',
    searchForm: 'magis',
  },
  {
    latin: 'magnitudo, -dines',
    info: 'v',
    definitions: ['grootte'],
    chapter: '32',
    searchForm: 'magnitudo, -dines',
  },
  {
    latin: 'magnopere',
    info: '',
    definitions: ['zeer, erg'],
    chapter: '17',
    searchForm: 'magnopere',
  },
  {
    latin: 'magnus, -a, -um',
    info: '',
    definitions: ['groot'],
    chapter: '15',
    searchForm: 'magnus, -a, -um',
  },
  {
    latin: 'maior',
    info: '',
    definitions: ['groter'],
    chapter: '18',
    searchForm: 'maior',
  },
  {
    latin: 'malle',
    info: 'inf.prs',
    definitions: ['liever willen'],
    chapter: '31',
    searchForm: 'malle',
  },
  {
    latin: 'malui',
    info: '',
    definitions: ['*pf van* malle'],
    chapter: '32',
    searchForm: 'malui',
  },
  {
    latin: 'malus, -a, -um',
    info: '',
    definitions: ['slecht'],
    chapter: '17',
    searchForm: 'malus, -a, -um',
  },
  {
    latin: 'mandare',
    info: '',
    definitions: ['opdragen'],
    chapter: '48',
    searchForm: 'mandare',
  },
  {
    latin: 'mandatum',
    info: '',
    definitions: ['opdracht'],
    chapter: '1',
    searchForm: 'mandatum',
  },
  {
    latin: 'manēre',
    info: '',
    definitions: ['blijven'],
    chapter: '8',
    searchForm: 'manere',
  },
  {
    latin: 'mansi',
    info: '',
    definitions: ['*pf van* manēre'],
    chapter: '52',
    searchForm: 'mansi',
  },
  {
    latin: 'mansurus',
    info: '',
    definitions: ['*pfa van* manēre'],
    chapter: '52',
    searchForm: 'mansurus',
  },
  {
    latin: 'manus',
    info: '4 v',
    definitions: ['hand'],
    chapter: '36',
    searchForm: 'manus',
  },
  {
    latin: 'mare, maria',
    info: '',
    definitions: ['zee'],
    chapter: '29',
    searchForm: 'mare, maria',
  },
  {
    latin: 'mari',
    info: '',
    definitions: ['*abl van* mare'],
    chapter: '29',
    searchForm: 'mari',
  },
  {
    latin: 'maritus',
    info: '',
    definitions: ['echtgenoot'],
    chapter: '15',
    searchForm: 'maritus',
  },
  {
    latin: 'mater, matres',
    info: 'v',
    definitions: ['moeder'],
    chapter: '2',
    searchForm: 'mater, matres',
  },
  {
    latin: 'matrona',
    info: '',
    definitions: ['matrona, vrouw des huizes'],
    chapter: '15',
    searchForm: 'matrona',
  },
  {
    latin: 'maxime',
    info: 'bijw',
    definitions: ['het meest', 'vooral'],
    chapter: '20',
    searchForm: 'maxime',
  },
  {
    latin: 'maximus, -a, -um',
    info: '',
    definitions: ['grootst, zeer groot'],
    chapter: '19',
    searchForm: 'maximus, -a, -um',
  },
  {
    latin: 'melior',
    info: '',
    definitions: ['beter'],
    chapter: '18',
    searchForm: 'melior',
  },
  {
    latin: 'meminisse',
    info: 'pf',
    definitions: [
      '**+ aci** zich herinneren dat',
      '**+gen** zich (iets) herinneren',
    ],
    chapter: '26',
    searchForm: 'meminisse',
  },
  {
    latin: 'mens, mentes',
    info: 'v',
    definitions: ['geest, verstand'],
    chapter: '33',
    searchForm: 'mens, mentes',
  },
  {
    latin: 'mensa',
    info: '',
    definitions: ['tafel'],
    chapter: '23',
    searchForm: 'mensa',
  },
  {
    latin: 'mercator, mercatores',
    info: 'm',
    definitions: ['koopman'],
    chapter: '32',
    searchForm: 'mercator, mercatores',
  },
  {
    latin: 'merēre',
    info: '',
    definitions: ['verdienen'],
    chapter: '31',
    searchForm: 'merere',
  },
  {
    latin: 'metuere',
    info: '',
    definitions: ['vrezen'],
    chapter: '39',
    searchForm: 'metuere',
  },
  {
    latin: 'metus',
    info: '4',
    definitions: ['vrees, zorg'],
    chapter: '36',
    searchForm: 'metus',
  },
  {
    latin: 'meus, -a, -um',
    info: '',
    definitions: ['mijn, van mij'],
    chapter: '15',
    searchForm: 'meus, -a, -um',
  },
  {
    latin: 'miles, milites',
    info: 'm',
    definitions: ['soldaat'],
    chapter: '4',
    searchForm: 'miles, milites',
  },
  {
    latin: 'militaris, -e',
    info: '',
    definitions: ['van de soldaat, militair'],
    chapter: '29',
    searchForm: 'militaris, -e',
  },
  {
    latin: 'militia',
    info: '',
    definitions: ['krijgsdienst'],
    chapter: '54',
    searchForm: 'militia',
  },
  {
    latin: 'mille, milia',
    info: '',
    definitions: ['duizend'],
    chapter: '20',
    searchForm: 'mille, milia',
  },
  {
    latin: 'minime',
    info: 'bijw',
    definitions: ['(aller)minst, helemaal niet'],
    chapter: '18',
    searchForm: 'minime',
  },
  {
    latin: 'minimus, -a, -um',
    info: '',
    definitions: ['kleinst, zeer klein'],
    chapter: '18',
    searchForm: 'minimus, -a, -um',
  },
  {
    latin: 'minor',
    info: '',
    definitions: ['kleiner'],
    chapter: '20',
    searchForm: 'minor',
  },
  {
    latin: 'minus',
    info: 'bijw',
    definitions: ['minder'],
    chapter: '20',
    searchForm: 'minus',
  },
  {
    latin: 'mirari',
    info: '',
    definitions: ['zich verwonderen', 'bewonderen'],
    chapter: '50',
    searchForm: 'mirari',
  },
  {
    latin: 'mirus, -a, -um',
    info: '',
    definitions: ['wonderlijk, bijzonder'],
    chapter: '32',
    searchForm: 'mirus, -a, -um',
  },
  {
    latin: 'miser, -sera, -serum',
    info: '',
    definitions: ['ongelukkig'],
    chapter: '15',
    searchForm: 'miser, -sera, -serum',
  },
  {
    latin: 'misericordia',
    info: '',
    definitions: ['medelijden'],
    chapter: '23',
    searchForm: 'misericordia',
  },
  {
    latin: 'misi',
    info: '',
    definitions: ['*pf van* mittere'],
    chapter: '20',
    searchForm: 'misi',
  },
  {
    latin: 'missus',
    info: '',
    definitions: ['*ppp van* mittere'],
    chapter: '38',
    searchForm: 'missus',
  },
  {
    latin: 'mittere',
    info: '',
    definitions: ['sturen'],
    chapter: '18',
    searchForm: 'mittere',
  },
  {
    latin: 'modo … modo',
    info: '',
    definitions: ['nu eens … dan weer'],
    chapter: '53',
    searchForm: 'modo … modo',
  },
  {
    latin: 'modus',
    info: '',
    definitions: ['manier', 'maat'],
    chapter: '55',
    searchForm: 'modus',
  },
  {
    latin: 'moenia',
    info: 'mv',
    definitions: ['(stads)muren'],
    chapter: '30',
    searchForm: 'moenia',
  },
  {
    latin: 'mollis, -e',
    info: '',
    definitions: ['zacht'],
    chapter: '24',
    searchForm: 'mollis, -e',
  },
  {
    latin: 'monēre',
    info: '',
    definitions: ['waarschuwen', 'aansporen'],
    chapter: '41',
    searchForm: 'monere',
  },
  {
    latin: 'mons, montes',
    info: 'm',
    definitions: ['berg, heuvel'],
    chapter: '3',
    searchForm: 'mons, montes',
  },
  {
    latin: 'morari',
    info: '',
    definitions: ['verblijven', '**+acc** vertragen'],
    chapter: '51',
    searchForm: 'morari',
  },
  {
    latin: 'morbus',
    info: '',
    definitions: ['ziekte'],
    chapter: '43',
    searchForm: 'morbus',
  },
  {
    latin: 'mori, morior',
    info: '',
    definitions: ['sterven'],
    chapter: '50',
    searchForm: 'mori, morior',
  },
  {
    latin: 'mors, mortes',
    info: 'v',
    definitions: ['(de) dood'],
    chapter: '15',
    searchForm: 'mors, mortes',
  },
  {
    latin: 'mortuus',
    info: '',
    definitions: ['dode'],
    chapter: '30',
    searchForm: 'mortuus',
  },
  {
    latin: 'mortuus sum',
    info: '',
    definitions: ['*pf van* mori'],
    chapter: '52',
    searchForm: 'mortuus sum',
  },
  {
    latin: 'mortuus, -a, -um',
    info: '',
    definitions: ['gestorven'],
    chapter: '30',
    searchForm: 'mortuus, -a, -um',
  },
  {
    latin: 'movēre',
    info: '',
    definitions: ['bewegen'],
    chapter: '19',
    searchForm: 'movere',
  },
  {
    latin: 'movi',
    info: '',
    definitions: ['*pf van* movēre'],
    chapter: '24',
    searchForm: 'movi',
  },
  {
    latin: 'mox',
    info: '',
    definitions: ['spoedig'],
    chapter: '5',
    searchForm: 'mox',
  },
  {
    latin: 'multitudo -tudines',
    info: 'v',
    definitions: ['menigte, massa'],
    chapter: '30',
    searchForm: 'multitudo, -tudines',
  },
  {
    latin: 'multo',
    info: 'bijw',
    definitions: ['veel'],
    chapter: '18',
    searchForm: 'multo',
  },
  {
    latin: 'multus, -a, -um',
    info: '',
    definitions: ['veel'],
    chapter: '15',
    searchForm: 'multus, -a, -um',
  },
  {
    latin: 'mundus',
    info: '',
    definitions: ['wereld'],
    chapter: '33',
    searchForm: 'mundus',
  },
  {
    latin: 'munus, munera',
    info: '',
    definitions: ['taak', 'geschenk'],
    chapter: '37',
    searchForm: 'munus, munera',
  },
  {
    latin: 'murus',
    info: '',
    definitions: ['muur'],
    chapter: '3',
    searchForm: 'murus',
  },
  {
    latin: 'mutare',
    info: '',
    definitions: ['veranderen'],
    chapter: '24',
    searchForm: 'mutare',
  },
  {
    latin: 'nam',
    info: '',
    definitions: ['want'],
    chapter: '2',
    searchForm: 'nam',
  },
  {
    latin: 'narrare',
    info: '',
    definitions: ['vertellen'],
    chapter: '6',
    searchForm: 'narrare',
  },
  {
    latin: 'navis, naves',
    info: 'v',
    definitions: ['schip'],
    chapter: '53',
    searchForm: 'navis, naves',
  },
  {
    latin: 'ne',
    info: '+ conj (BZ)',
    definitions: [
      '(met de bedoeling) dat niet, om niet te',
      '**ww van vrezen** dat',
    ],
    chapter: '44',
    searchForm: 'ne',
  },
  {
    latin: 'ne',
    info: '+ conj (HZ)',
    definitions: ['niet'],
    chapter: '43',
    searchForm: 'ne',
  },
  {
    latin: 'ne … quidem',
    info: '',
    definitions: ['zelfs niet'],
    chapter: '34',
    searchForm: 'ne … quidem',
  },
  {
    latin: 'necare',
    info: '',
    definitions: ['doden'],
    chapter: '1',
    searchForm: 'necare',
  },
  {
    latin: 'necesse est',
    info: '',
    definitions: ['het is nodig'],
    chapter: '27',
    searchForm: 'necesse est',
  },
  {
    latin: 'necessitas, -tates',
    info: 'v',
    definitions: ['noodzaak'],
    chapter: '52',
    searchForm: 'necessitas, -tates',
  },
  {
    latin: 'negare',
    info: '',
    definitions: ['ontkennen', 'weigeren'],
    chapter: '11',
    searchForm: 'negare',
  },
  {
    latin: 'neglegere',
    info: '',
    definitions: ['verwaarlozen'],
    chapter: '41',
    searchForm: 'neglegere',
  },
  {
    latin: 'negotium',
    info: '',
    definitions: ['bezigheid, zaak'],
    chapter: '55',
    searchForm: 'negotium',
  },
  {
    latin: 'nemo, nemines',
    info: 'm/v',
    definitions: ['niemand'],
    chapter: '9',
    searchForm: 'nemo, nemines',
  },
  {
    latin: 'neque',
    info: '',
    definitions: ['en niet, ook niet', 'maar niet'],
    chapter: '20',
    searchForm: 'neque',
  },
  {
    latin: 'neque … neque',
    info: '',
    definitions: ['niet … en ook niet'],
    chapter: '25',
    searchForm: 'neque … neque',
  },
  {
    latin: 'nescire',
    info: '',
    definitions: ['niet weten'],
    chapter: '27',
    searchForm: 'nescire',
  },
  {
    latin: 'nihil',
    info: '',
    definitions: ['niets'],
    chapter: '8',
    searchForm: 'nihil',
  },
  {
    latin: 'nimium',
    info: '+ gen',
    definitions: ['te veel'],
    chapter: '33',
    searchForm: 'nimium',
  },
  {
    latin: 'nisi',
    info: '',
    definitions: ['als niet', 'behalve'],
    chapter: '23, 32',
    searchForm: 'nisi',
  },
  {
    latin: 'nobilis, -e',
    info: '',
    definitions: ['adellijk, aanzienlijk'],
    chapter: '43',
    searchForm: 'nobilis, -e',
  },
  {
    latin: 'nocēre',
    info: '+ dat',
    definitions: ['schaden, kwaad doen'],
    chapter: '33',
    searchForm: 'nocere',
  },
  {
    latin: 'nolle',
    info: 'inf.prs',
    definitions: ['niet willen'],
    chapter: '33',
    searchForm: 'nolle',
  },
  {
    latin: 'nolui',
    info: '',
    definitions: ['*pf van* nolle'],
    chapter: '32, 55',
    searchForm: 'nolui',
  },
  {
    latin: 'nomen, nomina',
    info: '',
    definitions: ['naam'],
    chapter: '2',
    searchForm: 'nomen, nomina',
  },
  {
    latin: 'non',
    info: '',
    definitions: ['niet'],
    chapter: '1',
    searchForm: 'non',
  },
  {
    latin: 'non iam',
    info: '',
    definitions: ['niet meer'],
    chapter: '16',
    searchForm: 'non iam',
  },
  {
    latin: 'non quicquam',
    info: '',
    definitions: ['niets'],
    chapter: '46',
    searchForm: 'non quicquam',
  },
  {
    latin: 'non quisquam',
    info: '',
    definitions: ['niemand'],
    chapter: '46',
    searchForm: 'non quisquam',
  },
  {
    latin: 'nondum',
    info: '',
    definitions: ['nog niet'],
    chapter: '11',
    searchForm: 'nondum',
  },
  {
    latin: 'nonne',
    info: '',
    definitions: ['(toch) zeker wel'],
    chapter: '8',
    searchForm: 'nonne',
  },
  {
    latin: 'nonnulli, -ae, -a',
    info: 'mv',
    definitions: ['**bnw** sommige', '**znw** sommigen'],
    chapter: '27',
    searchForm: 'nonnulli, -ae, -a',
  },
  {
    latin: 'noscere',
    info: '',
    definitions: ['te weten komen', 'leren kennen'],
    chapter: '22',
    searchForm: 'noscere',
  },
  {
    latin: 'noster, -stra, -strum',
    info: '',
    definitions: ['ons, onze'],
    chapter: '15',
    searchForm: 'noster, -stra, -strum',
  },
  {
    latin: 'novi',
    info: '',
    definitions: ['*pf van* noscere'],
    chapter: '22',
    searchForm: 'novi',
  },
  {
    latin: 'novisse',
    info: 'pf',
    definitions: ['weten', 'kennen'],
    chapter: '22',
    searchForm: 'novisse',
  },
  {
    latin: 'novus, -a, -um',
    info: '',
    definitions: ['nieuw'],
    chapter: '15',
    searchForm: 'novus, -a, -um',
  },
  {
    latin: 'nox, noctes',
    info: 'v',
    definitions: ['nacht'],
    chapter: '4',
    searchForm: 'nox, noctes',
  },
  {
    latin: 'nubes, nubes',
    info: 'v',
    definitions: ['wolk'],
    chapter: '41',
    searchForm: 'nubes, nubes',
  },
  {
    latin: 'nudus, -a, -um',
    info: '',
    definitions: ['naakt, bloot'],
    chapter: '17',
    searchForm: 'nudus, -a, -um',
  },
  {
    latin: 'nullus, -a, -um',
    info: '',
    definitions: ['geen'],
    chapter: '24',
    searchForm: 'nullus, -a, -um',
  },
  {
    latin: 'num',
    info: '',
    definitions: ['(toch) zeker niet'],
    chapter: '6',
    searchForm: 'num',
  },
  {
    latin: 'numerus',
    info: '',
    definitions: ['aantal'],
    chapter: '20',
    searchForm: 'numerus',
  },
  {
    latin: 'numquam',
    info: '',
    definitions: ['nooit'],
    chapter: '9',
    searchForm: 'numquam',
  },
  {
    latin: 'nunc',
    info: '',
    definitions: ['nu'],
    chapter: '11',
    searchForm: 'nunc',
  },
  {
    latin: 'nuntiare',
    info: '',
    definitions: ['berichten, aankondigen'],
    chapter: '9',
    searchForm: 'nuntiare',
  },
  {
    latin: 'nuntius',
    info: '',
    definitions: ['bode', 'bericht'],
    chapter: '30',
    searchForm: 'nuntius',
  },
  {
    latin: 'nuper',
    info: '',
    definitions: ['kort geleden'],
    chapter: '5',
    searchForm: 'nuper',
  },
  {
    latin: 'nusquam',
    info: '',
    definitions: ['nergens'],
    chapter: '24',
    searchForm: 'nusquam',
  },
  {
    latin: 'ob',
    info: '+ acc',
    definitions: ['wegens'],
    chapter: '24',
    searchForm: 'ob',
  },
  {
    latin: 'oblatus',
    info: '',
    definitions: ['*pf van* offerre'],
    chapter: '32',
    searchForm: 'oblatus',
  },
  {
    latin: 'oblitus sum',
    info: '',
    definitions: ['*pf van* oblivisci'],
    chapter: '51',
    searchForm: 'oblitus sum',
  },
  {
    latin: 'oblivisci',
    info: '',
    definitions: ['vergeten'],
    chapter: '51',
    searchForm: 'oblivisci',
  },
  {
    latin: 'obsedi',
    info: '',
    definitions: ['*pf van* obsidēre'],
    chapter: '54',
    searchForm: 'obsedi',
  },
  {
    latin: 'obsessus',
    info: '',
    definitions: ['*ppp van* obsidēre'],
    chapter: '54',
    searchForm: 'obsessus',
  },
  {
    latin: 'obsidēre',
    info: '',
    definitions: ['belegeren'],
    chapter: '31',
    searchForm: 'obsidere',
  },
  {
    latin: 'obtentus',
    info: '',
    definitions: ['*ppp van* obtinēre'],
    chapter: '39',
    searchForm: 'obtentus',
  },
  {
    latin: 'obtinēre',
    info: '',
    definitions: ['in bezit krijgen', 'in bezit hebben'],
    chapter: '37',
    searchForm: 'obtinere',
  },
  {
    latin: 'obtinui',
    info: '',
    definitions: ['*pf van* obtinēre'],
    chapter: '39',
    searchForm: 'obtinui',
  },
  {
    latin: 'obtuli',
    info: '',
    definitions: ['*pf van* offerre'],
    chapter: '32',
    searchForm: 'obtuli',
  },
  {
    latin: 'oceanus',
    info: '',
    definitions: ['oceaan, zee'],
    chapter: '53',
    searchForm: 'oceanus',
  },
  {
    latin: 'oculus',
    info: '',
    definitions: ['oog'],
    chapter: '9',
    searchForm: 'oculus',
  },
  {
    latin: 'odisse',
    info: 'pf',
    definitions: ['haten'],
    chapter: '29',
    searchForm: 'odisse',
  },
  {
    latin: 'offerre',
    info: '',
    definitions: ['aanbieden'],
    chapter: '31',
    searchForm: 'offerre',
  },
  {
    latin: 'officium',
    info: '',
    definitions: ['plicht, taak'],
    chapter: '26',
    searchForm: 'officium',
  },
  {
    latin: 'olim',
    info: '',
    definitions: ['vroeger, eens'],
    chapter: '25',
    searchForm: 'olim',
  },
  {
    latin: 'omen, omina',
    info: '',
    definitions: ['voorteken'],
    chapter: '41',
    searchForm: 'omen, omina',
  },
  {
    latin: 'omittere',
    info: '',
    definitions: ['achterwege laten, weglaten'],
    chapter: '45',
    searchForm: 'omittere',
  },
  {
    latin: 'omnes',
    info: 'mv m/v',
    definitions: ['**bnw** alle', '**znw** allen'],
    chapter: '16',
    searchForm: 'omnes',
  },
  {
    latin: 'omnia',
    info: 'mv o',
    definitions: ['**bnw** alle', '**znw** alles'],
    chapter: '16',
    searchForm: 'omnia',
  },
  {
    latin: 'omnis, -e',
    info: 'ev',
    definitions: ['ieder, elk', 'geheel'],
    chapter: '16',
    searchForm: 'omnis, -e',
  },
  {
    latin: 'onus, onera',
    info: '',
    definitions: ['last, lading'],
    chapter: '18',
    searchForm: 'onus, onera',
  },
  {
    latin: 'oportet',
    info: '',
    definitions: ['het behoort'],
    chapter: '50',
    searchForm: 'oportet',
  },
  {
    latin: 'oppidum',
    info: '',
    definitions: ['(vesting)stad'],
    chapter: '37',
    searchForm: 'oppidum',
  },
  {
    latin: 'optimus, -a, -um',
    info: '',
    definitions: ['best, zeer goed'],
    chapter: '16',
    searchForm: 'optimus, -a, -um',
  },
  {
    latin: 'opus, opera',
    info: '',
    definitions: ['werk'],
    chapter: '22',
    searchForm: 'opus, opera',
  },
  {
    latin: 'orare',
    info: '',
    definitions: ['bidden (tot)', 'smeken (om)'],
    chapter: '5',
    searchForm: 'orare',
  },
  {
    latin: 'orbis, orbes',
    info: 'm',
    definitions: ['kring, cirkel'],
    chapter: '26',
    searchForm: 'orbis, orbes',
  },
  {
    latin: 'oriens, orientes',
    info: 'm',
    definitions: ['het oosten'],
    chapter: '47',
    searchForm: 'oriens, orientes',
  },
  {
    latin: 'oriri',
    info: '',
    definitions: ['ontstaan, opgaan'],
    chapter: '50',
    searchForm: 'oriri',
  },
  {
    latin: 'ortus sum',
    info: '',
    definitions: ['*pf van* oriri'],
    chapter: '50',
    searchForm: 'ortus sum',
  },
  {
    latin: 'ostendere',
    info: '',
    definitions: ['tonen'],
    chapter: '5',
    searchForm: 'ostendere',
  },
  {
    latin: 'ostendi',
    info: '',
    definitions: ['*pf van* ostendere'],
    chapter: '13',
    searchForm: 'ostendi',
  },
  {
    latin: 'paene',
    info: '',
    definitions: ['bijna'],
    chapter: '31',
    searchForm: 'paene',
  },
  {
    latin: 'par, par-',
    info: '',
    definitions: ['gelijk(waardig)', '**+ dat** opgewassen tegen'],
    chapter: '32',
    searchForm: 'par, par-',
  },
  {
    latin: 'parare',
    info: '',
    definitions: ['klaarmaken'],
    chapter: '12',
    searchForm: 'parare',
  },
  {
    latin: 'parcere',
    info: '+ dat',
    definitions: ['sparen'],
    chapter: '19',
    searchForm: 'parcere',
  },
  {
    latin: 'parentes',
    info: 'mv',
    definitions: ['ouders'],
    chapter: '16',
    searchForm: 'parentes',
  },
  {
    latin: 'parēre',
    info: '',
    definitions: ['gehoorzamen'],
    chapter: '31',
    searchForm: 'parere',
  },
  {
    latin: 'parere, pario',
    info: '',
    definitions: ['verwerven', 'voortbrengen'],
    chapter: '55',
    searchForm: 'parere, pario',
  },
  {
    latin: 'pars, partes',
    info: 'v',
    definitions: ['deel'],
    chapter: '4',
    searchForm: 'pars, partes',
  },
  {
    latin: 'partus',
    info: '',
    definitions: ['*ppp van* parere'],
    chapter: '55',
    searchForm: 'partus',
  },
  {
    latin: 'parum',
    info: 'bijw',
    definitions: ['niet genoeg'],
    chapter: '19',
    searchForm: 'parum',
  },
  {
    latin: 'parvus, -a, -um',
    info: '',
    definitions: ['klein'],
    chapter: '15',
    searchForm: 'parvus, -a, -um',
  },
  {
    latin: 'passus sum',
    info: '',
    definitions: ['*pf van* pati'],
    chapter: '50',
    searchForm: 'passus sum',
  },
  {
    latin: 'pater, patres',
    info: 'm',
    definitions: ['vader'],
    chapter: '2',
    searchForm: 'pater, patres',
  },
  {
    latin: 'patēre',
    info: '',
    definitions: ['openstaan'],
    chapter: '38',
    searchForm: 'patere',
  },
  {
    latin: 'pati, patior',
    info: '',
    definitions: ['lijden, doorstaan', 'toestaan'],
    chapter: '50',
    searchForm: 'pati, patior',
  },
  {
    latin: 'patria',
    info: '',
    definitions: ['vaderland'],
    chapter: '29',
    searchForm: 'patria',
  },
  {
    latin: 'pauci, -ae, -a',
    info: 'mv',
    definitions: ['weinig, enkele'],
    chapter: '20',
    searchForm: 'pauci, -ae, -a',
  },
  {
    latin: 'paulatim',
    info: '',
    definitions: ['langzamerhand'],
    chapter: '30',
    searchForm: 'paulatim',
  },
  {
    latin: 'paulo',
    info: '',
    definitions: ['een beetje'],
    chapter: '37',
    searchForm: 'paulo',
  },
  {
    latin: 'paulum',
    info: 'bijw',
    definitions: ['een beetje'],
    chapter: '17',
    searchForm: 'paulum',
  },
  {
    latin: 'pauper, pauper-',
    info: '',
    definitions: ['arm(oedig)'],
    chapter: '34',
    searchForm: 'pauper, pauper-',
  },
  {
    latin: 'pax, paces',
    info: 'v',
    definitions: ['vrede'],
    chapter: '31',
    searchForm: 'pax, paces',
  },
  {
    latin: 'pectus, pectora',
    info: '',
    definitions: ['borst'],
    chapter: '53',
    searchForm: 'pectus, pectora',
  },
  {
    latin: 'pecunia',
    info: '',
    definitions: ['geld'],
    chapter: '8',
    searchForm: 'pecunia',
  },
  {
    latin: 'peior',
    info: '',
    definitions: ['slechter'],
    chapter: '18',
    searchForm: 'peior',
  },
  {
    latin: 'pendēre',
    info: '',
    definitions: ['hangen'],
    chapter: '10',
    searchForm: 'pendere',
  },
  {
    latin: 'peperci',
    info: '',
    definitions: ['*pf van* parcere'],
    chapter: '19',
    searchForm: 'peperci',
  },
  {
    latin: 'peperi',
    info: '',
    definitions: ['*pf van* parere'],
    chapter: '55',
    searchForm: 'peperi',
  },
  {
    latin: 'per',
    info: '+ acc',
    definitions: ['door(heen)', 'gedurende', 'over(heen)'],
    chapter: '5, 10',
    searchForm: 'per',
  },
  {
    latin: 'perdere',
    info: '',
    definitions: ['vernietigen', 'verliezen'],
    chapter: '29, 46',
    searchForm: 'perdere',
  },
  {
    latin: 'perdidi',
    info: '',
    definitions: ['*pf van* perdere'],
    chapter: '46',
    searchForm: 'perdidi',
  },
  {
    latin: 'perditus',
    info: '',
    definitions: ['*ppp van* perdere'],
    chapter: '46',
    searchForm: 'perditus',
  },
  {
    latin: 'perfeci',
    info: '',
    definitions: ['*pf van* perficere'],
    chapter: '27',
    searchForm: 'perfeci',
  },
  {
    latin: 'perficere, perficio',
    info: '',
    definitions: ['voltooien'],
    chapter: '25',
    searchForm: 'perficere, perficio',
  },
  {
    latin: 'pergere',
    info: '',
    definitions: ['doorgaan'],
    chapter: '47',
    searchForm: 'pergere',
  },
  {
    latin: 'periculum',
    info: '',
    definitions: ['gevaar'],
    chapter: '4',
    searchForm: 'periculum',
  },
  {
    latin: 'perii',
    info: '',
    definitions: ['*pf van* perire'],
    chapter: '46',
    searchForm: 'perii',
  },
  {
    latin: 'perire',
    info: '',
    definitions: ['omkomen'],
    chapter: '46',
    searchForm: 'perire',
  },
  {
    latin: 'periturus',
    info: '',
    definitions: ['*pfa van* perire'],
    chapter: '46',
    searchForm: 'periturus',
  },
  {
    latin: 'permittere',
    info: '',
    definitions: ['toelaten, toestaan'],
    chapter: '29',
    searchForm: 'permittere',
  },
  {
    latin: 'perpetuus, -a, -um',
    info: '',
    definitions: ['voortdurend'],
    chapter: '25',
    searchForm: 'perpetuus, -a, -um',
  },
  {
    latin: 'perrexi',
    info: '',
    definitions: ['*pf van* pergere'],
    chapter: '47',
    searchForm: 'perrexi',
  },
  {
    latin: 'persuadēre',
    info: '+ dat',
    definitions: ['overhalen', 'overtuigen'],
    chapter: '45',
    searchForm: 'persuadere',
  },
  {
    latin: 'persuasi',
    info: '',
    definitions: ['*pf van* persuadēre'],
    chapter: '45',
    searchForm: 'persuasi',
  },
  {
    latin: 'persuasus',
    info: '',
    definitions: ['*ppp van* persuadēre'],
    chapter: '45',
    searchForm: 'persuasus',
  },
  {
    latin: 'pertinēre ad',
    info: '+ acc',
    definitions: ['zich uitstrekken tot', 'betrekking hebben op'],
    chapter: '51',
    searchForm: 'pertinere ad',
  },
  {
    latin: 'perveni',
    info: '',
    definitions: ['*pf van* pervenire'],
    chapter: '26',
    searchForm: 'perveni',
  },
  {
    latin: 'pervenire',
    info: '',
    definitions: ['aankomen'],
    chapter: '26',
    searchForm: 'pervenire',
  },
  {
    latin: 'pes, pedes',
    info: 'm',
    definitions: ['voet, poot'],
    chapter: '10',
    searchForm: 'pes, pedes',
  },
  {
    latin: 'pessimus, -a, -um',
    info: '',
    definitions: ['slechtst, zeer slecht'],
    chapter: '18',
    searchForm: 'pessimus, -a, -um',
  },
  {
    latin: 'petere',
    info: '',
    definitions: ['zoeken, vragen', 'proberen te bereiken', 'aanvallen'],
    chapter: '10, 32',
    searchForm: 'petere',
  },
  {
    latin: 'pietas, pietates',
    info: 'v',
    definitions: ['plichtsgevoel', 'liefde, trouw'],
    chapter: '41',
    searchForm: 'pietas, pietates',
  },
  {
    latin: 'placēre',
    info: '+ dat',
    definitions: ['bevallen, in de smaak vallen'],
    chapter: '3',
    searchForm: 'placere',
  },
  {
    latin: 'plebs, plebes',
    info: 'v',
    definitions: ['het gewone volk'],
    chapter: '39',
    searchForm: 'plebs, plebes',
  },
  {
    latin: 'plenus',
    info: '+ gen',
    definitions: ['vol (met)'],
    chapter: '25',
    searchForm: 'plenus',
  },
  {
    latin: 'plurimi, -ae, -a',
    info: 'mv',
    definitions: ['(de) meeste, zeer vele'],
    chapter: '20',
    searchForm: 'plurimi, -ae, -a',
  },
  {
    latin: 'plus, plures',
    info: 'com',
    definitions: ['meer'],
    chapter: '20',
    searchForm: 'plus, plures',
  },
  {
    latin: 'poculum',
    info: '',
    definitions: ['beker'],
    chapter: '8',
    searchForm: 'poculum',
  },
  {
    latin: 'poena',
    info: '',
    definitions: ['straf'],
    chapter: '5',
    searchForm: 'poena',
  },
  {
    latin: 'poeta',
    info: 'm',
    definitions: ['dichter'],
    chapter: '45',
    searchForm: 'poeta',
  },
  {
    latin: 'pondus, pondera',
    info: '',
    definitions: ['gewicht'],
    chapter: '33',
    searchForm: 'pondus, pondera',
  },
  {
    latin: 'ponere',
    info: '',
    definitions: ['plaatsen'],
    chapter: '1',
    searchForm: 'ponere',
  },
  {
    latin: 'pons, pontes',
    info: 'm',
    definitions: ['brug'],
    chapter: '48',
    searchForm: 'pons, pontes',
  },
  {
    latin: 'populus',
    info: '',
    definitions: ['volk'],
    chapter: '3',
    searchForm: 'populus',
  },
  {
    latin: 'porta',
    info: '',
    definitions: ['poort'],
    chapter: '30',
    searchForm: 'porta',
  },
  {
    latin: 'portare',
    info: '',
    definitions: ['dragen'],
    chapter: '1',
    searchForm: 'portare',
  },
  {
    latin: 'poscere',
    info: '',
    definitions: ['(op)eisen'],
    chapter: '54',
    searchForm: 'poscere',
  },
  {
    latin: 'positus',
    info: '',
    definitions: ['*ppp van* ponere'],
    chapter: '55',
    searchForm: 'positus',
  },
  {
    latin: 'posse',
    info: '',
    definitions: ['kunnen'],
    chapter: '9',
    searchForm: 'posse',
  },
  {
    latin: 'possedi',
    info: '',
    definitions: ['*pf van* possidēre'],
    chapter: '34',
    searchForm: 'possedi',
  },
  {
    latin: 'possessus',
    info: '',
    definitions: ['*ppp van* possidēre'],
    chapter: '32',
    searchForm: 'possessus',
  },
  {
    latin: 'possidēre',
    info: '',
    definitions: ['bezitten'],
    chapter: '23',
    searchForm: 'possidere',
  },
  {
    latin: 'post',
    info: '+ acc',
    definitions: ['achter', 'na'],
    chapter: '4, 27',
    searchForm: 'post',
  },
  {
    latin: 'post',
    info: 'bijw',
    definitions: ['later'],
    chapter: '27',
    searchForm: 'post',
  },
  {
    latin: 'postea',
    info: '',
    definitions: ['later'],
    chapter: '16',
    searchForm: 'postea',
  },
  {
    latin: 'posterus, -a, -um',
    info: '',
    definitions: ['volgend'],
    chapter: '38',
    searchForm: 'posterus, -a, -um',
  },
  {
    latin: 'postquam',
    info: '+ pf',
    definitions: ['nadat'],
    chapter: '12',
    searchForm: 'postquam',
  },
  {
    latin: 'postremo',
    info: '',
    definitions: ['tenslotte'],
    chapter: '30',
    searchForm: 'postremo',
  },
  {
    latin: 'posui',
    info: '',
    definitions: ['*pf van* ponere'],
    chapter: '13, 55',
    searchForm: 'posui',
  },
  {
    latin: 'potens, potent-',
    info: '',
    definitions: ['machtig'],
    chapter: '47',
    searchForm: 'potens, potent-',
  },
  {
    latin: 'potestas, -ates',
    info: 'v',
    definitions: ['macht', 'gelegenheid'],
    chapter: '34',
    searchForm: 'potestas, -ates',
  },
  {
    latin: 'potiri',
    info: '+ abl',
    definitions: ['zich meester maken van'],
    chapter: '54',
    searchForm: 'potiri',
  },
  {
    latin: 'potius',
    info: 'bijw',
    definitions: ['liever, eerder'],
    chapter: '51',
    searchForm: 'potius',
  },
  {
    latin: 'potui',
    info: '',
    definitions: ['*pf van* posse'],
    chapter: '12',
    searchForm: 'potui',
  },
  {
    latin: 'praebēre',
    info: '',
    definitions: ['(aan)bieden'],
    chapter: '2',
    searchForm: 'praebere',
  },
  {
    latin: 'praeceptum',
    info: '',
    definitions: ['voorschrift'],
    chapter: '52',
    searchForm: 'praeceptum',
  },
  {
    latin: 'praeda',
    info: '',
    definitions: ['buit'],
    chapter: '44',
    searchForm: 'praeda',
  },
  {
    latin: 'praeferre',
    info: '',
    definitions: ['liever hebben, verkiezen'],
    chapter: '34',
    searchForm: 'praeferre',
  },
  {
    latin: 'praelatus',
    info: '',
    definitions: ['*ppp van* praeferre'],
    chapter: '32',
    searchForm: 'praelatus',
  },
  {
    latin: 'praemium',
    info: '',
    definitions: ['beloning'],
    chapter: '37',
    searchForm: 'praemium',
  },
  {
    latin: 'praestare',
    info: '',
    definitions: ['verrichten', '**se** zich betonen'],
    chapter: '39',
    searchForm: 'praestare',
  },
  {
    latin: 'praeterea',
    info: '',
    definitions: ['bovendien'],
    chapter: '23',
    searchForm: 'praeterea',
  },
  {
    latin: 'praeterii',
    info: '',
    definitions: ['*pf van* praeterire'],
    chapter: '26',
    searchForm: 'praeterii',
  },
  {
    latin: 'praeterire',
    info: '',
    definitions: ['voorbijgaan'],
    chapter: '26',
    searchForm: 'praeterire',
  },
  {
    latin: 'praeteriturus',
    info: '',
    definitions: ['*pfa van* praeterire'],
    chapter: '32',
    searchForm: 'praeteriturus',
  },
  {
    latin: 'praetuli',
    info: '',
    definitions: ['*pf van* praeferre'],
    chapter: '32',
    searchForm: 'praetuli',
  },
  {
    latin: 'premere',
    info: '',
    definitions: ['drukken (op)'],
    chapter: '26',
    searchForm: 'premere',
  },
  {
    latin: 'pressi',
    info: '',
    definitions: ['*pf van* premere'],
    chapter: '32, 48',
    searchForm: 'pressi',
  },
  {
    latin: 'pressus',
    info: '',
    definitions: ['*ppp van* premere'],
    chapter: '32, 48',
    searchForm: 'pressus',
  },
  {
    latin: 'pretium',
    info: '',
    definitions: ['prijs'],
    chapter: '18',
    searchForm: 'pretium',
  },
  {
    latin: 'primum',
    info: 'bijw',
    definitions: ['eerst'],
    chapter: '3',
    searchForm: 'primum',
  },
  {
    latin: 'primus, -a, -um',
    info: '',
    definitions: ['eerste'],
    chapter: '25',
    searchForm: 'primus, -a, -um',
  },
  {
    latin: 'princeps, princip-',
    info: '',
    definitions: ['voornaamste'],
    chapter: '38',
    searchForm: 'princeps, princip-',
  },
  {
    latin: 'princeps, principes',
    info: 'm',
    definitions: ['leider'],
    chapter: '38',
    searchForm: 'princeps, principes',
  },
  {
    latin: 'prior, prius',
    info: '',
    definitions: ['eerdere, eerste'],
    chapter: '43',
    searchForm: 'prior, prius',
  },
  {
    latin: 'priusquam',
    info: '',
    definitions: ['voordat'],
    chapter: '13',
    searchForm: 'priusquam',
  },
  {
    latin: 'privatus, -a, -um',
    info: '',
    definitions: ['persoonlijk'],
    chapter: '30',
    searchForm: 'privatus, -a, -um',
  },
  {
    latin: 'pro',
    info: '+ abl',
    definitions: ['voor', 'in plaats van'],
    chapter: '6',
    searchForm: 'pro',
  },
  {
    latin: 'procedere',
    info: '',
    definitions: ['voortgaan, lopen'],
    chapter: '10',
    searchForm: 'procedere',
  },
  {
    latin: 'processi',
    info: '',
    definitions: ['*pf van* procedere'],
    chapter: '17',
    searchForm: 'processi',
  },
  {
    latin: 'processus',
    info: '',
    definitions: ['*ppp van* procedere'],
    chapter: '32',
    searchForm: 'processus',
  },
  {
    latin: 'procul',
    info: '',
    definitions: ['ver, in de verte'],
    chapter: '26',
    searchForm: 'procul',
  },
  {
    latin: 'prodesse',
    info: '',
    definitions: ['voordelig zijn'],
    chapter: '39',
    searchForm: 'prodesse',
  },
  {
    latin: 'proelium',
    info: '',
    definitions: ['gevecht, veldslag'],
    chapter: '31',
    searchForm: 'proelium',
  },
  {
    latin: 'profectus sum',
    info: '',
    definitions: ['*pf van* proficisci'],
    chapter: '50',
    searchForm: 'profectus sum',
  },
  {
    latin: 'proficisci',
    info: '',
    definitions: ['vertrekken'],
    chapter: '50',
    searchForm: 'proficisci',
  },
  {
    latin: 'profui',
    info: '',
    definitions: ['*pf van* prodesse'],
    chapter: '54',
    searchForm: 'profui',
  },
  {
    latin: 'profuturus',
    info: '',
    definitions: ['*pfa van* prodesse'],
    chapter: '54',
    searchForm: 'profuturus',
  },
  {
    latin: 'prohibēre',
    info: '',
    definitions: ['**(a(b)) + abl** afhouden van', '**+ inf** verhinderen'],
    chapter: '48, 52',
    searchForm: 'prohibere',
  },
  {
    latin: 'promisi',
    info: '',
    definitions: ['*pf van* promittere'],
    chapter: '32',
    searchForm: 'promisi',
  },
  {
    latin: 'promissus',
    info: '',
    definitions: ['*ppp van* promittere'],
    chapter: '32',
    searchForm: 'promissus',
  },
  {
    latin: 'promittere',
    info: '',
    definitions: ['beloven'],
    chapter: '32',
    searchForm: 'promittere',
  },
  {
    latin: 'prope',
    info: '+ acc',
    definitions: ['dichtbij'],
    chapter: '6',
    searchForm: 'prope',
  },
  {
    latin: 'properare',
    info: '',
    definitions: ['zich haasten'],
    chapter: '38',
    searchForm: 'properare',
  },
  {
    latin: 'proponere',
    info: '',
    definitions: ['voorleggen', 'voorstellen'],
    chapter: '38',
    searchForm: 'proponere',
  },
  {
    latin: 'propositus',
    info: '',
    definitions: ['*ppp van* proponere'],
    chapter: '38, 44',
    searchForm: 'propositus',
  },
  {
    latin: 'proposui',
    info: '',
    definitions: ['*pf van* proponere'],
    chapter: '38, 44',
    searchForm: 'proposui',
  },
  {
    latin: 'proprius, -a, -um',
    info: '',
    definitions: ['eigen'],
    chapter: '54',
    searchForm: 'proprius, -a, -um',
  },
  {
    latin: 'propter',
    info: '+ acc',
    definitions: ['wegens'],
    chapter: '31',
    searchForm: 'propter',
  },
  {
    latin: 'protegere',
    info: '',
    definitions: ['beschermen'],
    chapter: '2',
    searchForm: 'protegere',
  },
  {
    latin: 'protexi',
    info: '',
    definitions: ['*pf van* protegere'],
    chapter: '16',
    searchForm: 'protexi',
  },
  {
    latin: 'provincia',
    info: '',
    definitions: ['provincie, ambtsgebied'],
    chapter: '47',
    searchForm: 'provincia',
  },
  {
    latin: 'prudens, prudent-',
    info: '',
    definitions: ['verstandig'],
    chapter: '18',
    searchForm: 'prudens, prudent-',
  },
  {
    latin: 'publicus, -a, -um',
    info: '',
    definitions: ['openbaar'],
    chapter: '30',
    searchForm: 'publicus, -a, -um',
  },
  {
    latin: 'puella',
    info: '',
    definitions: ['meisje'],
    chapter: '4',
    searchForm: 'puella',
  },
  {
    latin: 'puer, pueri',
    info: '',
    definitions: ['jongen'],
    chapter: '1',
    searchForm: 'puer, pueri',
  },
  {
    latin: 'pugna',
    info: '',
    definitions: ['gevecht'],
    chapter: '6',
    searchForm: 'pugna',
  },
  {
    latin: 'pugnare',
    info: '',
    definitions: ['vechten'],
    chapter: '6',
    searchForm: 'pugnare',
  },
  {
    latin: 'pulcher, -chra, -chrum',
    info: '',
    definitions: ['mooi'],
    chapter: '15',
    searchForm: 'pulcher, -chra, -chrum',
  },
  {
    latin: 'punire',
    info: '',
    definitions: ['straffen'],
    chapter: '24',
    searchForm: 'punire',
  },
  {
    latin: 'putare',
    info: '',
    definitions: ['menen', 'vinden, beschouwen als'],
    chapter: '18',
    searchForm: 'putare',
  },
  {
    latin: 'quaerere',
    info: '',
    definitions: ['zoeken', 'vragen'],
    chapter: '17',
    searchForm: 'quaerere',
  },
  {
    latin: 'quaesitus',
    info: '',
    definitions: ['*ppp van* quaerere'],
    chapter: '29',
    searchForm: 'quaesitus',
  },
  {
    latin: 'quaesivi',
    info: '',
    definitions: ['*pf van* quaerere'],
    chapter: '34',
    searchForm: 'quaesivi',
  },
  {
    latin: 'qualis, -e',
    info: '',
    definitions: ['hoedanig', 'zodanig als'],
    chapter: '47',
    searchForm: 'qualis, -e',
  },
  {
    latin: 'quam',
    info: 'uitroep',
    definitions: ['wat, hoe'],
    chapter: '43',
    searchForm: 'quam',
  },
  {
    latin: 'quam',
    info: '',
    definitions: ['**+ comp** … dan', '**+ sup** zo … mogelijk'],
    chapter: '18',
    searchForm: 'quam',
  },
  {
    latin: 'quamquam',
    info: '',
    definitions: ['hoewel'],
    chapter: '23',
    searchForm: 'quamquam',
  },
  {
    latin: 'quando',
    info: '',
    definitions: ['wanneer'],
    chapter: '8',
    searchForm: 'quando',
  },
  {
    latin: 'quantus, -a, -um',
    info: '',
    definitions: ['hoe groot', 'zo groot als'],
    chapter: '30',
    searchForm: 'quantus, -a, -um',
  },
  {
    latin: 'quare',
    info: '',
    definitions: ['waarom'],
    chapter: '34',
    searchForm: 'quare',
  },
  {
    latin: 'quasi',
    info: '',
    definitions: ['als(of)', 'als het ware'],
    chapter: '34',
    searchForm: 'quasi',
  },
  {
    latin: 'queri',
    info: '(+ acc)',
    definitions: ['klagen (over)'],
    chapter: '51',
    searchForm: 'queri',
  },
  {
    latin: 'questus sum',
    info: '',
    definitions: ['*pf van* queri'],
    chapter: '51',
    searchForm: 'questus sum',
  },
  {
    latin: 'qui, quae, quod',
    info: '',
    definitions: ['welke', 'die, dat'],
    chapter: '24',
    searchForm: 'qui, quae, quod',
  },
  {
    latin: 'quia',
    info: '',
    definitions: ['omdat'],
    chapter: '19',
    searchForm: 'quia',
  },
  {
    latin: 'quicquam',
    info: '',
    definitions: ['iets'],
    chapter: '46',
    searchForm: 'quicquam',
  },
  {
    latin: 'quid',
    info: '',
    definitions: ['wat'],
    chapter: '9',
    searchForm: 'quid',
  },
  {
    latin: 'quidam, quaedam, quoddam',
    info: '',
    definitions: [
      '**ev** een (zekere), een of andere',
      '**mv** sommige, enige',
    ],
    chapter: '46',
    searchForm: 'quidam, quaedam, quoddam',
  },
  {
    latin: 'quidem … sed',
    info: '',
    definitions: ['wel(iswaar) … maar'],
    chapter: '11',
    searchForm: 'quidem … sed',
  },
  {
    latin: 'quies, quietes',
    info: 'v',
    definitions: ['rust'],
    chapter: '48',
    searchForm: 'quies, quietes',
  },
  {
    latin: 'quietus, -a, -um',
    info: '',
    definitions: ['rustig'],
    chapter: '51',
    searchForm: 'quietus, -a, -um',
  },
  {
    latin: 'quis',
    info: '',
    definitions: ['wie'],
    chapter: '9',
    searchForm: 'quis',
  },
  {
    latin: 'quisquam',
    info: '',
    definitions: ['iemand'],
    chapter: '46',
    searchForm: 'quisquam',
  },
  {
    latin: 'quisque',
    info: '',
    definitions: ['iedereen'],
    chapter: '27',
    searchForm: 'quisque',
  },
  {
    latin: 'quisque, quaeque, quodque',
    info: '',
    definitions: ['iedere, elke'],
    chapter: '46',
    searchForm: 'quisque, quaeque, quodque',
  },
  {
    latin: 'quo',
    info: '',
    definitions: ['waarheen'],
    chapter: '9',
    searchForm: 'quo',
  },
  {
    latin: 'quod',
    info: '',
    definitions: ['omdat', '(datgene) wat'],
    chapter: '8',
    searchForm: 'quod',
  },
  {
    latin: 'quomodo',
    info: '',
    definitions: ['hoe'],
    chapter: '22',
    searchForm: 'quomodo',
  },
  {
    latin: 'quondam',
    info: '',
    definitions: ['eens, ooit'],
    chapter: '13',
    searchForm: 'quondam',
  },
  {
    latin: 'quoniam',
    info: '',
    definitions: ['aangezien'],
    chapter: '37',
    searchForm: 'quoniam',
  },
  {
    latin: 'quoque',
    info: '',
    definitions: ['ook'],
    chapter: '3',
    searchForm: 'quoque',
  },
  {
    latin: 'rapere, rapio',
    info: '',
    definitions: ['roven', 'grijpen'],
    chapter: '27',
    searchForm: 'rapere, rapio',
  },
  {
    latin: 'rapui',
    info: '',
    definitions: ['*pf van* rapere'],
    chapter: '27',
    searchForm: 'rapui',
  },
  {
    latin: 'ratus sum',
    info: '',
    definitions: ['*pf van* reri'],
    chapter: '50',
    searchForm: 'ratus sum',
  },
  {
    latin: 'recepi',
    info: '',
    definitions: ['*pf van* recipere'],
    chapter: '46, 55',
    searchForm: 'recepi',
  },
  {
    latin: 'receptus',
    info: '',
    definitions: ['*ppp van* recipere'],
    chapter: '46, 55',
    searchForm: 'receptus',
  },
  {
    latin: 'recipere, recipio',
    info: '',
    definitions: ['ontvangen', '**se** zich terugtrekken'],
    chapter: '36',
    searchForm: 'recipere, recipio',
  },
  {
    latin: 'rectus, -a, -um',
    info: '',
    definitions: ['recht, juist'],
    chapter: '43',
    searchForm: 'rectus, -a, -um',
  },
  {
    latin: 'recusare',
    info: '',
    definitions: ['weigeren'],
    chapter: '1',
    searchForm: 'recusare',
  },
  {
    latin: 'reddere',
    info: '',
    definitions: ['teruggeven'],
    chapter: '53',
    searchForm: 'reddere',
  },
  {
    latin: 'reddidi',
    info: '',
    definitions: ['*pf van* reddere'],
    chapter: '53',
    searchForm: 'reddidi',
  },
  {
    latin: 'redditus',
    info: '',
    definitions: ['*ppp van* reddere'],
    chapter: '53',
    searchForm: 'redditus',
  },
  {
    latin: 'redii',
    info: '',
    definitions: ['*pf van* redire'],
    chapter: '32, 41',
    searchForm: 'redii',
  },
  {
    latin: 'redire',
    info: '',
    definitions: ['teruggaan'],
    chapter: '20',
    searchForm: 'redire',
  },
  {
    latin: 'rediturus',
    info: '',
    definitions: ['*pfa van* redire'],
    chapter: '32, 41',
    searchForm: 'rediturus',
  },
  {
    latin: 'referre',
    info: '',
    definitions: ['terugbrengen', '(be)halen', 'rapporteren'],
    chapter: '31',
    searchForm: 'referre',
  },
  {
    latin: 'regere',
    info: '',
    definitions: ['besturen, leiden'],
    chapter: '12',
    searchForm: 'regere',
  },
  {
    latin: 'regina',
    info: '',
    definitions: ['koningin'],
    chapter: '40',
    searchForm: 'regina',
  },
  {
    latin: 'regio, regiones',
    info: 'v',
    definitions: ['streek, gebied'],
    chapter: '27',
    searchForm: 'regio, regiones',
  },
  {
    latin: 'regnare',
    info: '',
    definitions: ['koning zijn'],
    chapter: '40',
    searchForm: 'regnare',
  },
  {
    latin: 'regnum',
    info: '',
    definitions: ['koningschap', 'koninkrijk'],
    chapter: '32',
    searchForm: 'regnum',
  },
  {
    latin: 'relatus',
    info: '',
    definitions: ['*ppp van* referre'],
    chapter: '31, 53',
    searchForm: 'relatus',
  },
  {
    latin: 'relictus',
    info: '',
    definitions: ['*ppp van* relinquere'],
    chapter: '31',
    searchForm: 'relictus',
  },
  {
    latin: 'relinquere',
    info: '',
    definitions: ['verlaten', 'achterlaten'],
    chapter: '20',
    searchForm: 'relinquere',
  },
  {
    latin: 'reliqui',
    info: '',
    definitions: ['*pf van* relinquere'],
    chapter: '20',
    searchForm: 'reliqui',
  },
  {
    latin: 'reperire',
    info: '',
    definitions: ['vinden, ontdekken'],
    chapter: '53',
    searchForm: 'reperire',
  },
  {
    latin: 'repertus',
    info: '',
    definitions: ['*ppp van* reperire'],
    chapter: '53',
    searchForm: 'repertus',
  },
  {
    latin: 'repetere',
    info: '',
    definitions: ['herhalen'],
    chapter: '24',
    searchForm: 'repetere',
  },
  {
    latin: 'repetivi',
    info: '',
    definitions: ['*pf van* repetere'],
    chapter: '24',
    searchForm: 'repetivi',
  },
  {
    latin: 'repperi',
    info: '',
    definitions: ['*pf van* reperire'],
    chapter: '53',
    searchForm: 'repperi',
  },
  {
    latin: 'reri',
    info: '',
    definitions: ['menen'],
    chapter: '50',
    searchForm: 'reri',
  },
  {
    latin: 'res',
    info: '5',
    definitions: ['zaak, ding, kwestie'],
    chapter: '36',
    searchForm: 'res',
  },
  {
    latin: 'res gestae',
    info: 'mv',
    definitions: ['(oorlogs)daden'],
    chapter: '44',
    searchForm: 'res gestae',
  },
  {
    latin: 'res publica',
    info: '',
    definitions: ['staat, republiek'],
    chapter: '39',
    searchForm: 'res publica',
  },
  {
    latin: 'resistere',
    info: '',
    definitions: ['weerstand bieden'],
    chapter: '10',
    searchForm: 'resistere',
  },
  {
    latin: 'respondēre',
    info: '',
    definitions: ['antwoorden'],
    chapter: '8',
    searchForm: 'respondere',
  },
  {
    latin: 'respondi',
    info: '',
    definitions: ['*pf van* respondēre'],
    chapter: '12',
    searchForm: 'respondi',
  },
  {
    latin: 'retinēre',
    info: '',
    definitions: ['tegenhouden'],
    chapter: '4',
    searchForm: 'retinere',
  },
  {
    latin: 'rettuli',
    info: '',
    definitions: ['*pf van* referre'],
    chapter: '53',
    searchForm: 'rettuli',
  },
  {
    latin: 'retuli',
    info: '',
    definitions: ['*pf van* referre'],
    chapter: '32',
    searchForm: 'retuli',
  },
  {
    latin: 'revocare',
    info: '',
    definitions: ['terugroepen'],
    chapter: '31',
    searchForm: 'revocare',
  },
  {
    latin: 'rex, reges',
    info: 'm',
    definitions: ['koning'],
    chapter: '1',
    searchForm: 'rex, reges',
  },
  {
    latin: 'rexi',
    info: '',
    definitions: ['*pf van* regere'],
    chapter: '12',
    searchForm: 'rexi',
  },
  {
    latin: 'ridēre',
    info: '',
    definitions: ['lachen'],
    chapter: '2',
    searchForm: 'ridere',
  },
  {
    latin: 'ripa',
    info: '',
    definitions: ['oever'],
    chapter: '54',
    searchForm: 'ripa',
  },
  {
    latin: 'risi',
    info: '',
    definitions: ['*pf van* ridēre'],
    chapter: '12',
    searchForm: 'risi',
  },
  {
    latin: 'rogare',
    info: '',
    definitions: ['vragen'],
    chapter: '8',
    searchForm: 'rogare',
  },
  {
    latin: 'Roma',
    info: '',
    definitions: ['Rome'],
    chapter: '4',
    searchForm: 'Roma',
  },
  {
    latin: 'Romae',
    info: '',
    definitions: ['te Rome, in Rome'],
    chapter: '20',
    searchForm: 'Romae',
  },
  {
    latin: 'Romam',
    info: 'bijw',
    definitions: ['naar Rome'],
    chapter: '13',
    searchForm: 'Romam',
  },
  {
    latin: 'Romanus',
    info: '',
    definitions: ['Romein'],
    chapter: '4',
    searchForm: 'Romanus',
  },
  {
    latin: 'Romanus, -a, -um',
    info: '',
    definitions: ['Romeins'],
    chapter: '15',
    searchForm: 'Romanus, -a, -um',
  },
  {
    latin: 'ruere',
    info: '',
    definitions: ['zich haasten', 'neerstorten, instorten'],
    chapter: '27',
    searchForm: 'ruere',
  },
  {
    latin: 'rui',
    info: '',
    definitions: ['*pf van* ruere'],
    chapter: '27, 51',
    searchForm: 'rui',
  },
  {
    latin: 'rumpere',
    info: '',
    definitions: ['breken'],
    chapter: '52',
    searchForm: 'rumpere',
  },
  {
    latin: 'rutus',
    info: '',
    definitions: ['*ppp van* ruere'],
    chapter: '51',
    searchForm: 'rutus',
  },
  {
    latin: 'sacer, -cra, -crum',
    info: '',
    definitions: ['heilig', '**+ dat** gewijd aan'],
    chapter: '46',
    searchForm: 'sacer, -cra, -crum',
  },
  {
    latin: 'sacerdos, sacerdotes',
    info: 'm',
    definitions: ['priester'],
    chapter: '46',
    searchForm: 'sacerdos, sacerdotes',
  },
  {
    latin: 'saeculum',
    info: '',
    definitions: ['tijdperk, eeuw'],
    chapter: '47',
    searchForm: 'saeculum',
  },
  {
    latin: 'saepe',
    info: '',
    definitions: ['vaak'],
    chapter: '12',
    searchForm: 'saepe',
  },
  {
    latin: 'saevus, -a, -um',
    info: '',
    definitions: ['wild, woest'],
    chapter: '37',
    searchForm: 'saevus, -a, -um',
  },
  {
    latin: 'salus, salutes',
    info: 'v',
    definitions: ['welzijn', 'redding'],
    chapter: '45',
    searchForm: 'salus, salutes',
  },
  {
    latin: 'salutare',
    info: '',
    definitions: ['(be)groeten'],
    chapter: '10',
    searchForm: 'salutare',
  },
  {
    latin: 'sanctus, -a, -um',
    info: '',
    definitions: ['heilig, onschendbaar'],
    chapter: '46',
    searchForm: 'sanctus, -a, -um',
  },
  {
    latin: 'sanguis, sanguines',
    info: 'm',
    definitions: ['bloed'],
    chapter: '9',
    searchForm: 'sanguis, sanguines',
  },
  {
    latin: 'sapientia',
    info: '',
    definitions: ['wijsheid'],
    chapter: '43',
    searchForm: 'sapientia',
  },
  {
    latin: 'satis',
    info: '',
    definitions: ['genoeg'],
    chapter: '12',
    searchForm: 'satis',
  },
  {
    latin: 'saxum',
    info: '',
    definitions: ['rots, rotsblok'],
    chapter: '3',
    searchForm: 'saxum',
  },
  {
    latin: 'scelus, scelera',
    info: '',
    definitions: ['misdaad'],
    chapter: '54',
    searchForm: 'scelus, scelera',
  },
  {
    latin: 'scientia',
    info: '',
    definitions: ['kennis, wetenschap'],
    chapter: '33',
    searchForm: 'scientia',
  },
  {
    latin: 'scii',
    info: '',
    definitions: ['*pf van* scire'],
    chapter: '25',
    searchForm: 'scii',
  },
  {
    latin: 'scilicet',
    info: '',
    definitions: ['natuurlijk'],
    chapter: '6',
    searchForm: 'scilicet',
  },
  {
    latin: 'scire',
    info: '',
    definitions: ['weten'],
    chapter: '11',
    searchForm: 'scire',
  },
  {
    latin: 'scivi',
    info: '',
    definitions: ['*pf van* scire'],
    chapter: '25',
    searchForm: 'scivi',
  },
  {
    latin: 'scribere',
    info: '',
    definitions: ['schrijven'],
    chapter: '50',
    searchForm: 'scribere',
  },
  {
    latin: 'scripsi',
    info: '',
    definitions: ['*pf van* scribere'],
    chapter: '50',
    searchForm: 'scripsi',
  },
  {
    latin: 'scriptus',
    info: '',
    definitions: ['*ppp van* scribere'],
    chapter: '51',
    searchForm: 'scriptus',
  },
  {
    latin: 'se',
    info: '',
    definitions: ['zich(zelf)', '**aci** dat hij, dat zij'],
    chapter: '19, 25',
    searchForm: 'se',
  },
  {
    latin: 'secundus, -a, -um',
    info: '',
    definitions: ['tweede'],
    chapter: '17',
    searchForm: 'secundus, -a, -um',
  },
  {
    latin: 'securus, -a, -um',
    info: '',
    definitions: ['onbezorgd'],
    chapter: '46',
    searchForm: 'securus, -a, -um',
  },
  {
    latin: 'secutus sum',
    info: '',
    definitions: ['*pf van* sequi'],
    chapter: '52',
    searchForm: 'secutus sum',
  },
  {
    latin: 'sed',
    info: '',
    definitions: ['maar'],
    chapter: '3',
    searchForm: 'sed',
  },
  {
    latin: 'sedēre',
    info: '',
    definitions: ['zitten'],
    chapter: '6',
    searchForm: 'sedere',
  },
  {
    latin: 'sedes, sedes',
    info: 'v',
    definitions: ['zitplaats', 'woonplaats'],
    chapter: '48',
    searchForm: 'sedes, sedes',
  },
  {
    latin: 'sedi',
    info: '',
    definitions: ['*pf van* sedēre'],
    chapter: '55',
    searchForm: 'sedi',
  },
  {
    latin: 'semel',
    info: '',
    definitions: ['eenmaal'],
    chapter: '55',
    searchForm: 'semel',
  },
  {
    latin: 'semper',
    info: '',
    definitions: ['altijd'],
    chapter: '4',
    searchForm: 'semper',
  },
  {
    latin: 'senator, senatores',
    info: 'm',
    definitions: ['senator'],
    chapter: '29',
    searchForm: 'senator, senatores',
  },
  {
    latin: 'senatus',
    info: '4',
    definitions: ['senaat'],
    chapter: '39',
    searchForm: 'senatus',
  },
  {
    latin: 'senex, senes',
    info: 'm',
    definitions: ['oude man'],
    chapter: '13',
    searchForm: 'senex, senes',
  },
  {
    latin: 'sensi',
    info: '',
    definitions: ['*pf van* sentire'],
    chapter: '24',
    searchForm: 'sensi',
  },
  {
    latin: 'sententia',
    info: '',
    definitions: ['mening', 'uitspraak, zin'],
    chapter: '22',
    searchForm: 'sententia',
  },
  {
    latin: 'sentire',
    info: '',
    definitions: ['merken, voelen', 'menen'],
    chapter: '24',
    searchForm: 'sentire',
  },
  {
    latin: 'sequi',
    info: '',
    definitions: ['volgen'],
    chapter: '52',
    searchForm: 'sequi',
  },
  {
    latin: 'sermo, sermones',
    info: 'm',
    definitions: ['gesprek'],
    chapter: '13',
    searchForm: 'sermo, sermones',
  },
  {
    latin: 'serva',
    info: '',
    definitions: ['slavin'],
    chapter: '23',
    searchForm: 'serva',
  },
  {
    latin: 'servare',
    info: '',
    definitions: ['redden'],
    chapter: '4',
    searchForm: 'servare',
  },
  {
    latin: 'servus',
    info: '',
    definitions: ['slaaf'],
    chapter: '1',
    searchForm: 'servus',
  },
  {
    latin: 'sessus',
    info: '',
    definitions: ['*ppp van* sedēre'],
    chapter: '55',
    searchForm: 'sessus',
  },
  {
    latin: 'si',
    info: '',
    definitions: ['als, indien'],
    chapter: '4',
    searchForm: 'si',
  },
  {
    latin: 'sibi',
    info: 'dat',
    definitions: ['(aan/voor) zichzelf'],
    chapter: '40',
    searchForm: 'sibi',
  },
  {
    latin: 'sic',
    info: '',
    definitions: ['zo'],
    chapter: '2',
    searchForm: 'sic',
  },
  {
    latin: 'sicut',
    info: '',
    definitions: ['zoals'],
    chapter: '2',
    searchForm: 'sicut',
  },
  {
    latin: 'signum',
    info: '',
    definitions: ['teken', 'veldteken'],
    chapter: '5, 53',
    searchForm: 'signum',
  },
  {
    latin: 'silentium',
    info: '',
    definitions: ['stilte'],
    chapter: '4',
    searchForm: 'silentium',
  },
  {
    latin: 'silva',
    info: '',
    definitions: ['bos'],
    chapter: '19',
    searchForm: 'silva',
  },
  {
    latin: 'similis, -e',
    info: '',
    definitions: ['gelijk'],
    chapter: '16',
    searchForm: 'similis, -e',
  },
  {
    latin: 'simulare',
    info: '',
    definitions: ['doen alsof, simuleren'],
    chapter: '40',
    searchForm: 'simulare',
  },
  {
    latin: 'sine',
    info: '+ abl',
    definitions: ['zonder'],
    chapter: '11',
    searchForm: 'sine',
  },
  {
    latin: 'singuli, -ae, -a',
    info: 'mv',
    definitions: ['stuk voor stuk'],
    chapter: '38',
    searchForm: 'singuli, -ae, -a',
  },
  {
    latin: 'socius',
    info: '',
    definitions: ['bondgenoot'],
    chapter: '37',
    searchForm: 'socius',
  },
  {
    latin: 'sol, soles',
    info: 'm',
    definitions: ['zon'],
    chapter: '5',
    searchForm: 'sol, soles',
  },
  {
    latin: 'solēre',
    info: '',
    definitions: ['gewend zijn, gewoon zijn'],
    chapter: '51',
    searchForm: 'solere',
  },
  {
    latin: 'solitus sum',
    info: '',
    definitions: ['*pf van* solēre'],
    chapter: '50',
    searchForm: 'solitus sum',
  },
  {
    latin: 'solus, -a, -um',
    info: '',
    definitions: ['alleen'],
    chapter: '37',
    searchForm: 'solus, -a, -um',
  },
  {
    latin: 'solutus',
    info: '',
    definitions: ['*ppp van* solvere'],
    chapter: '52',
    searchForm: 'solutus',
  },
  {
    latin: 'solvere',
    info: '',
    definitions: ['losmaken', 'betalen'],
    chapter: '44',
    searchForm: 'solvere',
  },
  {
    latin: 'solvi',
    info: '',
    definitions: ['*pf van* solvere'],
    chapter: '52',
    searchForm: 'solvi',
  },
  {
    latin: 'somnium',
    info: '',
    definitions: ['droom'],
    chapter: '41',
    searchForm: 'somnium',
  },
  {
    latin: 'soror, sorores',
    info: 'v',
    definitions: ['zus'],
    chapter: '8',
    searchForm: 'soror, sorores',
  },
  {
    latin: 'sors, sortes',
    info: 'v',
    definitions: ['lot, toeval'],
    chapter: '43',
    searchForm: 'sors, sortes',
  },
  {
    latin: 'spargere',
    info: '',
    definitions: ['strooien', 'verspreiden'],
    chapter: '50',
    searchForm: 'spargere',
  },
  {
    latin: 'sparsi',
    info: '',
    definitions: ['*pf van* spargere'],
    chapter: '50',
    searchForm: 'sparsi',
  },
  {
    latin: 'sparsus',
    info: '',
    definitions: ['*ppp van* spargere'],
    chapter: '50',
    searchForm: 'sparsus',
  },
  {
    latin: 'spatium',
    info: '',
    definitions: ['afstand', 'ruimte'],
    chapter: '31',
    searchForm: 'spatium',
  },
  {
    latin: 'species',
    info: '5',
    definitions: ['uiterlijk'],
    chapter: '37',
    searchForm: 'species',
  },
  {
    latin: 'spectaculum',
    info: '',
    definitions: ['voorstelling'],
    chapter: '9',
    searchForm: 'spectaculum',
  },
  {
    latin: 'spectare',
    info: '',
    definitions: ['kijken (naar)'],
    chapter: '9',
    searchForm: 'spectare',
  },
  {
    latin: 'spectator, spectatores',
    info: 'm',
    definitions: ['toeschouwer'],
    chapter: '8',
    searchForm: 'spectator, spectatores',
  },
  {
    latin: 'sperare',
    info: '',
    definitions: ['hopen'],
    chapter: '33',
    searchForm: 'sperare',
  },
  {
    latin: 'spernere',
    info: '',
    definitions: ['afwijzen'],
    chapter: '24',
    searchForm: 'spernere',
  },
  {
    latin: 'spes',
    info: '5',
    definitions: ['hoop, verwachting'],
    chapter: '38',
    searchForm: 'spes',
  },
  {
    latin: 'spiritus',
    info: '4',
    definitions: ['adem', 'geest'],
    chapter: '40',
    searchForm: 'spiritus',
  },
  {
    latin: 'sprevi',
    info: '',
    definitions: ['*pf van* spernere'],
    chapter: '24',
    searchForm: 'sprevi',
  },
  {
    latin: 'stare',
    info: '',
    definitions: ['staan'],
    chapter: '3',
    searchForm: 'stare',
  },
  {
    latin: 'statim',
    info: '',
    definitions: ['meteen'],
    chapter: '4',
    searchForm: 'statim',
  },
  {
    latin: 'statuere',
    info: '',
    definitions: ['besluiten'],
    chapter: '48',
    searchForm: 'statuere',
  },
  {
    latin: 'statui',
    info: '',
    definitions: ['*pf van* statuere'],
    chapter: '48',
    searchForm: 'statui',
  },
  {
    latin: 'statutus',
    info: '',
    definitions: ['*ppp van* statuere'],
    chapter: '48',
    searchForm: 'statutus',
  },
  {
    latin: 'sternere',
    info: '',
    definitions: ['neergooien', 'bedekken'],
    chapter: '53',
    searchForm: 'sternere',
  },
  {
    latin: 'strepitus',
    info: '4',
    definitions: ['lawaai'],
    chapter: '36',
    searchForm: 'strepitus',
  },
  {
    latin: 'studēre',
    info: '(+ dat)',
    definitions: ['zijn best doen (voor)'],
    chapter: '47',
    searchForm: 'studere',
  },
  {
    latin: 'studium',
    info: '',
    definitions: ['ijver, enthousiasme', 'studie'],
    chapter: '34',
    searchForm: 'studium',
  },
  {
    latin: 'stultus, -a, -um',
    info: '',
    definitions: ['dom'],
    chapter: '22',
    searchForm: 'stultus, -a, -um',
  },
  {
    latin: 'suadēre',
    info: '',
    definitions: ['aanraden, adviseren'],
    chapter: '48',
    searchForm: 'suadere',
  },
  {
    latin: 'suasi',
    info: '',
    definitions: ['*pf van* suadēre'],
    chapter: '48',
    searchForm: 'suasi',
  },
  {
    latin: 'suasus',
    info: '',
    definitions: ['*ppp van* suadēre'],
    chapter: '48',
    searchForm: 'suasus',
  },
  {
    latin: 'sub',
    info: '+ abl',
    definitions: ['onder'],
    chapter: '8',
    searchForm: 'sub',
  },
  {
    latin: 'subito',
    info: '',
    definitions: ['plotseling'],
    chapter: '2',
    searchForm: 'subito',
  },
  {
    latin: 'sumere',
    info: '',
    definitions: ['nemen'],
    chapter: '23',
    searchForm: 'sumere',
  },
  {
    latin: 'summus, -a, -um',
    info: '',
    definitions: ['hoogste', 'de top van'],
    chapter: '33',
    searchForm: 'summus, -a, -um',
  },
  {
    latin: 'sumpsi',
    info: '',
    definitions: ['*pf van* sumere'],
    chapter: '23',
    searchForm: 'sumpsi',
  },
  {
    latin: 'super',
    info: '+ acc',
    definitions: ['boven(op), over'],
    chapter: '5',
    searchForm: 'super',
  },
  {
    latin: 'superare',
    info: '',
    definitions: ['overtreffen', 'overwinnen'],
    chapter: '9',
    searchForm: 'superare',
  },
  {
    latin: 'superbia',
    info: '',
    definitions: ['trots, arrogantie'],
    chapter: '24',
    searchForm: 'superbia',
  },
  {
    latin: 'supra',
    info: '+ acc',
    definitions: ['boven'],
    chapter: '41',
    searchForm: 'supra',
  },
  {
    latin: 'supra',
    info: 'bijw',
    definitions: ['(er)boven'],
    chapter: '41',
    searchForm: 'supra',
  },
  {
    latin: 'surgere',
    info: '',
    definitions: ['opstaan'],
    chapter: '40',
    searchForm: 'surgere',
  },
  {
    latin: 'surrectus',
    info: '',
    definitions: ['*ppp van* surgere'],
    chapter: '40',
    searchForm: 'surrectus',
  },
  {
    latin: 'surrexi',
    info: '',
    definitions: ['*pf van* surgere'],
    chapter: '40',
    searchForm: 'surrexi',
  },
  {
    latin: 'sustuli',
    info: '',
    definitions: ['*pf van* tollere'],
    chapter: '13',
    searchForm: 'sustuli',
  },
  {
    latin: 'suus, -a, -um',
    info: '',
    definitions: ['zijn (eigen)', 'haar (eigen)', 'hun (eigen)'],
    chapter: '15',
    searchForm: 'suus, -a, -um',
  },
  {
    latin: 'tacēre',
    info: '',
    definitions: ['zwijgen'],
    chapter: '3',
    searchForm: 'tacere',
  },
  {
    latin: 'talis, -e',
    info: '',
    definitions: ['zodanig'],
    chapter: '43',
    searchForm: 'talis, -e',
  },
  {
    latin: 'tam',
    info: '',
    definitions: ['zo'],
    chapter: '37',
    searchForm: 'tam',
  },
  {
    latin: 'tamen',
    info: '',
    definitions: ['toch'],
    chapter: '1',
    searchForm: 'tamen',
  },
  {
    latin: 'tandem',
    info: '',
    definitions: ['eindelijk'],
    chapter: '3',
    searchForm: 'tandem',
  },
  {
    latin: 'tangere',
    info: '',
    definitions: ['aanraken'],
    chapter: '12',
    searchForm: 'tangere',
  },
  {
    latin: 'tantum',
    info: 'bijw',
    definitions: ['slechts, alleen maar'],
    chapter: '5',
    searchForm: 'tantum',
  },
  {
    latin: 'tantus, -a, -um',
    info: '',
    definitions: ['zo groot'],
    chapter: '44',
    searchForm: 'tantus, -a, -um',
  },
  {
    latin: 'tardus, -a, -um',
    info: '',
    definitions: ['traag', 'laat'],
    chapter: '45',
    searchForm: 'tardus, -a, -um',
  },
  {
    latin: 'tegere',
    info: '',
    definitions: ['bedekken'],
    chapter: '55',
    searchForm: 'tegere',
  },
  {
    latin: 'templum',
    info: '',
    definitions: ['tempel'],
    chapter: '6',
    searchForm: 'templum',
  },
  {
    latin: 'temptare',
    info: '',
    definitions: ['proberen'],
    chapter: '4',
    searchForm: 'temptare',
  },
  {
    latin: 'tempus, tempora',
    info: '',
    definitions: ['tijd, periode'],
    chapter: '15',
    searchForm: 'tempus, tempora',
  },
  {
    latin: 'tener, -era, -erum',
    info: '',
    definitions: ['teer', 'jong'],
    chapter: '33',
    searchForm: 'tener, -era, -erum',
  },
  {
    latin: 'tenēre',
    info: '',
    definitions: ['(vast)houden'],
    chapter: '10',
    searchForm: 'tenere',
  },
  {
    latin: 'terra',
    info: '',
    definitions: ['aarde, grond'],
    chapter: '10',
    searchForm: 'terra',
  },
  {
    latin: 'terrēre',
    info: '',
    definitions: ['bang maken'],
    chapter: '11',
    searchForm: 'terrere',
  },
  {
    latin: 'tetigi',
    info: '',
    definitions: ['*pf van* tangere'],
    chapter: '12',
    searchForm: 'tetigi',
  },
  {
    latin: 'timēre',
    info: '',
    definitions: ['vrezen, bang zijn voor'],
    chapter: '1',
    searchForm: 'timere',
  },
  {
    latin: 'timidus, -a, -um',
    info: '',
    definitions: ['angstig, timide'],
    chapter: '17',
    searchForm: 'timidus, -a, -um',
  },
  {
    latin: 'tollere',
    info: '',
    definitions: ['optillen'],
    chapter: '1',
    searchForm: 'tollere',
  },
  {
    latin: 'totus, -a, -um',
    info: '',
    definitions: ['(ge)heel'],
    chapter: '31',
    searchForm: 'totus, -a, -um',
  },
  {
    latin: 'tradere',
    info: '',
    definitions: ['overhandigen'],
    chapter: '2',
    searchForm: 'tradere',
  },
  {
    latin: 'tradidi',
    info: '',
    definitions: ['*pf van* tradere'],
    chapter: '16',
    searchForm: 'tradidi',
  },
  {
    latin: 'trahere',
    info: '',
    definitions: ['trekken'],
    chapter: '36',
    searchForm: 'trahere',
  },
  {
    latin: 'trans',
    info: '+ acc',
    definitions: ['over, aan de overzijde van'],
    chapter: '13',
    searchForm: 'trans',
  },
  {
    latin: 'transii',
    info: '',
    definitions: ['*pf van* transire'],
    chapter: '32, 39',
    searchForm: 'transii',
  },
  {
    latin: 'transire',
    info: '',
    definitions: ['oversteken'],
    chapter: '39',
    searchForm: 'transire',
  },
  {
    latin: 'transiturus',
    info: '',
    definitions: ['*pfa van* transire'],
    chapter: '32, 39',
    searchForm: 'transiturus',
  },
  {
    latin: 'tremere',
    info: '',
    definitions: ['trillen, beven'],
    chapter: '27',
    searchForm: 'tremere',
  },
  {
    latin: 'tribuere',
    info: '',
    definitions: ['toekennen'],
    chapter: '19',
    searchForm: 'tribuere',
  },
  {
    latin: 'tristis, -e',
    info: '',
    definitions: ['droevig, somber'],
    chapter: '17',
    searchForm: 'tristis, -e',
  },
  {
    latin: 'tueri',
    info: '',
    definitions: ['bekijken, onderzoeken', 'beschermen'],
    chapter: '51',
    searchForm: 'tueri',
  },
  {
    latin: 'tuli',
    info: '',
    definitions: ['*pf van* ferre'],
    chapter: '32',
    searchForm: 'tuli',
  },
  {
    latin: 'tumultus',
    info: '4',
    definitions: ['opschudding, tumult'],
    chapter: '36',
    searchForm: 'tumultus',
  },
  {
    latin: 'tunc',
    info: '',
    definitions: ['op dat moment, toen'],
    chapter: '11',
    searchForm: 'tunc',
  },
  {
    latin: 'turba',
    info: '',
    definitions: ['menigte'],
    chapter: '4',
    searchForm: 'turba',
  },
  {
    latin: 'turbare',
    info: '',
    definitions: ['verstoren'],
    chapter: '48',
    searchForm: 'turbare',
  },
  {
    latin: 'tutus, -a, -um',
    info: '',
    definitions: ['veilig'],
    chapter: '30',
    searchForm: 'tutus, -a, -um',
  },
  {
    latin: 'tuus, -a, -um',
    info: '',
    definitions: ['jouw, uw'],
    chapter: '15',
    searchForm: 'tuus, -a, -um',
  },
  {
    latin: 'ubi',
    info: '',
    definitions: ['waar'],
    chapter: '1',
    searchForm: 'ubi',
  },
  {
    latin: 'ubique',
    info: '',
    definitions: ['overal'],
    chapter: '9',
    searchForm: 'ubique',
  },
  {
    latin: 'ullus, -a, -um',
    info: '',
    definitions: ['enige, een of andere'],
    chapter: '47',
    searchForm: 'ullus, -a, -um',
  },
  {
    latin: 'ultimus, -a, -um',
    info: '',
    definitions: ['laatste, uiterste'],
    chapter: '24',
    searchForm: 'ultimus, -a, -um',
  },
  {
    latin: 'ultro',
    info: '',
    definitions: ['uit zichzelf'],
    chapter: '24',
    searchForm: 'ultro',
  },
  {
    latin: 'umbra',
    info: '',
    definitions: ['schaduw', 'schim *(van een overledene)*'],
    chapter: '10, 17',
    searchForm: 'umbra',
  },
  {
    latin: 'umquam',
    info: '',
    definitions: ['ooit'],
    chapter: '29',
    searchForm: 'umquam',
  },
  {
    latin: 'unda',
    info: '',
    definitions: ['golf'],
    chapter: '53',
    searchForm: 'unda',
  },
  {
    latin: 'unde',
    info: '',
    definitions: ['waarvandaan'],
    chapter: '27',
    searchForm: 'unde',
  },
  {
    latin: 'undique',
    info: '',
    definitions: ['van alle kanten'],
    chapter: '53',
    searchForm: 'undique',
  },
  {
    latin: 'universus, -a, -um',
    info: '',
    definitions: ['gezamenlijk'],
    chapter: '36',
    searchForm: 'universus, -a, -um',
  },
  {
    latin: 'unus, -a, -um',
    info: '',
    definitions: ['één'],
    chapter: '15',
    searchForm: 'unus, -a, -um',
  },
  {
    latin: 'urbs, urbes',
    info: 'v',
    definitions: ['stad'],
    chapter: '3',
    searchForm: 'urbs, urbes',
  },
  {
    latin: 'urgēre',
    info: '',
    definitions: ['in het nauw brengen'],
    chapter: '36',
    searchForm: 'urgere',
  },
  {
    latin: 'usque ad',
    info: '+ acc',
    definitions: ['tot aan'],
    chapter: '37',
    searchForm: 'usque ad',
  },
  {
    latin: 'usus',
    info: '4',
    definitions: ['gebruik', 'nut'],
    chapter: '52',
    searchForm: 'usus',
  },
  {
    latin: 'usus sum',
    info: '',
    definitions: ['*pf van* uti'],
    chapter: '51',
    searchForm: 'usus sum',
  },
  {
    latin: 'ut',
    info: '+ conj',
    definitions: [
      '(met de bedoeling) dat, om te',
      '(met het gevolg) dat, zodat',
    ],
    chapter: '44',
    searchForm: 'ut',
  },
  {
    latin: 'ut',
    info: '+ ind',
    definitions: ['zoals', '**+ pf** zodra'],
    chapter: '23',
    searchForm: 'ut',
  },
  {
    latin: 'uter, utra, utrum',
    info: '',
    definitions: ['welk(e) van beiden'],
    chapter: '36',
    searchForm: 'uter, utra, utrum',
  },
  {
    latin: 'uterque, utraque, utrumque',
    info: '',
    definitions: ['elk van beide'],
    chapter: '36, 54',
    searchForm: 'uterque, utraque, utrumque',
  },
  {
    latin: 'uti',
    info: '+ abl',
    definitions: ['gebruiken'],
    chapter: '50',
    searchForm: 'uti',
  },
  {
    latin: 'utilis, -e',
    info: '',
    definitions: ['nuttig'],
    chapter: '33',
    searchForm: 'utilis, -e',
  },
  {
    latin: 'utinam',
    info: '',
    definitions: ['*leidt een wens in (niet vertalen)*'],
    chapter: '43',
    searchForm: 'utinam',
  },
  {
    latin: 'utique',
    info: '',
    definitions: ['hoe dan ook'],
    chapter: '47',
    searchForm: 'utique',
  },
  {
    latin: 'utrum … an',
    info: '',
    definitions: ['(of) … of'],
    chapter: '22',
    searchForm: 'utrum … an',
  },
  {
    latin: 'uxor, uxores',
    info: 'v',
    definitions: ['echtgenote'],
    chapter: '2',
    searchForm: 'uxor, uxores',
  },
  {
    latin: 'valde',
    info: '',
    definitions: ['zeer, erg'],
    chapter: '9',
    searchForm: 'valde',
  },
  {
    latin: 'vale, *mv* valete',
    info: '',
    definitions: ['gegroet, vaarwel'],
    chapter: '53',
    searchForm: 'vale, *mv* valete',
  },
  {
    latin: 'varius, -a, -um',
    info: '',
    definitions: ['verschillend, afwisselend'],
    chapter: '51',
    searchForm: 'varius, -a, -um',
  },
  {
    latin: 'vates, vates',
    info: 'm',
    definitions: ['waarzegger', 'zanger'],
    chapter: '48',
    searchForm: 'vates, vates',
  },
  {
    latin: 'vehemens, vehement-',
    info: '',
    definitions: ['hevig, krachtig'],
    chapter: '27',
    searchForm: 'vehemens, vehement-',
  },
  {
    latin: 'vehere',
    info: '',
    definitions: ['**act** vervoeren', '**pass** reizen'],
    chapter: '52',
    searchForm: 'vehere',
  },
  {
    latin: 'velle',
    info: 'inf.prs',
    definitions: ['willen'],
    chapter: '31',
    searchForm: 'velle',
  },
  {
    latin: 'vendere',
    info: '',
    definitions: ['verkopen'],
    chapter: '6',
    searchForm: 'vendere',
  },
  {
    latin: 'vendidi',
    info: '',
    definitions: ['*pf van* vendere'],
    chapter: '25',
    searchForm: 'vendidi',
  },
  {
    latin: 'veni',
    info: '',
    definitions: ['*pf van* venire'],
    chapter: '12',
    searchForm: 'veni',
  },
  {
    latin: 'venire',
    info: '',
    definitions: ['komen'],
    chapter: '1',
    searchForm: 'venire',
  },
  {
    latin: 'ventus',
    info: '',
    definitions: ['wind'],
    chapter: '50',
    searchForm: 'ventus',
  },
  {
    latin: 'verbum',
    info: '',
    definitions: ['woord'],
    chapter: '11',
    searchForm: 'verbum',
  },
  {
    latin: 'vereri',
    info: '',
    definitions: ['vrezen'],
    chapter: '50',
    searchForm: 'vereri',
  },
  {
    latin: 'vero',
    info: '',
    definitions: ['inderdaad', 'echter'],
    chapter: '22',
    searchForm: 'vero',
  },
  {
    latin: 'vertere',
    info: '',
    definitions: ['keren, wenden'],
    chapter: '11',
    searchForm: 'vertere',
  },
  {
    latin: 'verti',
    info: '',
    definitions: ['*pf van* vertere'],
    chapter: '23',
    searchForm: 'verti',
  },
  {
    latin: 'verus, -a, -um',
    info: '',
    definitions: ['echt, waar'],
    chapter: '34',
    searchForm: 'verus, -a, -um',
  },
  {
    latin: 'vester, -stra, -strum',
    info: '',
    definitions: ['jullie, van jullie'],
    chapter: '15',
    searchForm: 'vester, -stra, -strum',
  },
  {
    latin: 'vestis, vestes',
    info: 'v',
    definitions: ['kleding(stuk)'],
    chapter: '17',
    searchForm: 'vestis, vestes',
  },
  {
    latin: 'vetare',
    info: '',
    definitions: ['verbieden'],
    chapter: '8',
    searchForm: 'vetare',
  },
  {
    latin: 'vetus, veter-',
    info: '',
    definitions: ['oud'],
    chapter: '27',
    searchForm: 'vetus, veter-',
  },
  {
    latin: 'via',
    info: '',
    definitions: ['weg, straat'],
    chapter: '8',
    searchForm: 'via',
  },
  {
    latin: 'vici',
    info: '',
    definitions: ['*pf van* vincere'],
    chapter: '12',
    searchForm: 'vici',
  },
  {
    latin: 'victor, victores',
    info: 'm',
    definitions: ['(over)winnaar'],
    chapter: '11',
    searchForm: 'victor, victores',
  },
  {
    latin: 'victoria',
    info: '',
    definitions: ['overwinning'],
    chapter: '6',
    searchForm: 'victoria',
  },
  {
    latin: 'victurus',
    info: '',
    definitions: ['*pfa van* vivere'],
    chapter: '43',
    searchForm: 'victurus',
  },
  {
    latin: 'victus',
    info: '',
    definitions: ['*ppp van* vincere'],
    chapter: '31',
    searchForm: 'victus',
  },
  {
    latin: 'vidēre',
    info: '',
    definitions: ['zien'],
    chapter: '1',
    searchForm: 'videre',
  },
  {
    latin: 'videri',
    info: '',
    definitions: ['schijnen, lijken'],
    chapter: '50',
    searchForm: 'videri',
  },
  {
    latin: 'vidi',
    info: '',
    definitions: ['*pf van* vidēre'],
    chapter: '13',
    searchForm: 'vidi',
  },
  {
    latin: 'villa',
    info: '',
    definitions: ['landgoed'],
    chapter: '26',
    searchForm: 'villa',
  },
  {
    latin: 'vincere',
    info: '',
    definitions: ['(over)winnen'],
    chapter: '6',
    searchForm: 'vincere',
  },
  {
    latin: 'vinum',
    info: '',
    definitions: ['wijn'],
    chapter: '10',
    searchForm: 'vinum',
  },
  {
    latin: 'vir, *mv* viri',
    info: '',
    definitions: ['man'],
    chapter: '3',
    searchForm: 'vir, *mv* viri',
  },
  {
    latin: 'virgo, virgines',
    info: 'v',
    definitions: ['meisje, maagd'],
    chapter: '39',
    searchForm: 'virgo, virgines',
  },
  {
    latin: 'virtus, virtutes',
    info: 'v',
    definitions: ['dapperheid'],
    chapter: '22',
    searchForm: 'virtus, virtutes',
  },
  {
    latin: 'vis *van* velle',
    info: '',
    definitions: ['jij wilt'],
    chapter: '31',
    searchForm: 'vis *van* velle',
  },
  {
    latin: 'vis, vires',
    info: 'v',
    definitions: ['kracht, geweld'],
    chapter: '37',
    searchForm: 'vis, vires',
  },
  {
    latin: 'visus sum',
    info: '',
    definitions: ['*pf van* videri'],
    chapter: '50',
    searchForm: 'visus sum',
  },
  {
    latin: 'vita',
    info: '',
    definitions: ['(het) leven'],
    chapter: '6',
    searchForm: 'vita',
  },
  {
    latin: 'vitare',
    info: '',
    definitions: ['vermijden'],
    chapter: '11',
    searchForm: 'vitare',
  },
  {
    latin: 'vivere',
    info: '',
    definitions: ['leven'],
    chapter: '5',
    searchForm: 'vivere',
  },
  {
    latin: 'vivus, -a, -um',
    info: '',
    definitions: ['levend'],
    chapter: '38',
    searchForm: 'vivus, -a, -um',
  },
  {
    latin: 'vix',
    info: '',
    definitions: ['met moeite, nauwelijks'],
    chapter: '38',
    searchForm: 'vix',
  },
  {
    latin: 'vixi',
    info: '',
    definitions: ['*pf van* vivere'],
    chapter: '13, 43',
    searchForm: 'vixi',
  },
  {
    latin: 'vocare',
    info: '',
    definitions: ['roepen', 'noemen'],
    chapter: '1',
    searchForm: 'vocare',
  },
  {
    latin: 'volui',
    info: '',
    definitions: ['*pf van* velle'],
    chapter: '32',
    searchForm: 'volui',
  },
  {
    latin: 'vox, voces',
    info: 'v',
    definitions: ['stem', 'uitspraak'],
    chapter: '16',
    searchForm: 'vox, voces',
  },
  {
    latin: 'vulnerare',
    info: '',
    definitions: ['verwonden'],
    chapter: '10',
    searchForm: 'vulnerare',
  },
  {
    latin: 'vulnus, vulnera',
    info: '',
    definitions: ['wond'],
    chapter: '19',
    searchForm: 'vulnus, vulnera',
  },
  {
    latin: 'vultus',
    info: '4',
    definitions: ['gezicht'],
    chapter: '41',
    searchForm: 'vultus',
  },
]

module.exports = dictionaryData



// WEBPACK FOOTER //
// ./src/apps/vocabularium/data/words.js